import moment from "moment";
import Select from "react-select";
import { cloneDeep } from "lodash";
import Cards from "react-credit-cards";
import OtpInput from "react-otp-input";
import React, { Component, Fragment } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import NotificationSystem from "react-notification-system";
import {
  Container,
  Col,
  Row,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Navbar,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  CustomInput,
  CardImg,
  Table,
  Alert,
  Tooltip,
  FormFeedback,
} from "reactstrap";
import { GoVerified, GoUnverified } from "react-icons/go";
import { MdEdit, MdDeleteForever } from "react-icons/md";
import { FaRegCheckCircle } from "react-icons/fa";
import PageSpinner from "../components/PageSpinner";

import "../styles/login.css";
import { NOTIFICATION_SYSTEM_STYLE } from "../utils/constants";
import * as Server from "../Server";
import bn from "../utils/bemnames";
// import DefaultImage from "../assets/img/defaultUser.png";
import * as GeneralFunctions from "../GeneralFunctions";

const bem = bn.create("header");
let childNameTextAreaStyle = {
  height: "calc(1.5em + 0.75rem + 2px)",
};

class EventRegistrationForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      clubId: "",
      parentId: "",
      adult: {},
      player: {},
      childs: [],
      selectedChild: {},
      submitType: "",
      showLoader: false,
      disabledFields: false,
      playerDisabledFields: false,
      verificationModal: false,
      registerFormFieldsAdult: [],
      registerFormFieldsPlayers: [],
      wavierFormFieldsAdult: [],
      wavierFormFieldsPlayers: [],
      selectedEventForAPI: {},
      camps: [],
      registerChild: false,
      showPayButton: false,
      registerFor: "parent",
      registerNewChild: false,
      newChildId: "",
      showPaymentPage: false,
      cvc: "",
      name: "",
      number: "",
      expiry: "",
      cardType: "",
      focus: "number",
      stripeCards: [],
      selectedCard: {},
      eventPriceDetails: {},
      paymentConfirmationModal: false,
      paymentSuccessMessage: "",
      closeAlert: false,
      eventId: "",
      event: {},
      codeVerified: false,
      code: "",
      unverifiedEmailTooltip: false,
      verifiedEmailTooltip: false,
      unverifiedPhoneTooltip: false,
      verifiedPhoneTooltip: false,
      phoneOtp: "",
      phoneOtpSent: false,
      phoneOtpVerified: false,
      emailOtp: "",
      emailOtpSent: false,
      emailOtpVerified: false,
      fullPayment: true,
      paymentSuccessConfirmationModal: false,
      selectedTabIndex: 0,
      cashPayment: false,
      showCashPaymentButton: false,
      installments: 0,
      installmentDates: [],
      note: "",
      eventExpired: false,
      teamQuantity: 0,
      teamQuantityValues: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      couponCode: "",
      invalidCode: false,
      validCode: false,
      coupon: {},
      multiplePlayers: [],
      multipleAdults: [],
      redirect: false,
    };
    this.onSubmit = this.onSubmit.bind(this);
  }

  dataURItoBlob(dataURI) {
    // convert base64/URLEncoded data component to raw binary data held in a string
    var byteString;
    if (dataURI.split(",")[0].indexOf("base64") >= 0)
      byteString = atob(dataURI.split(",")[1]);
    else byteString = unescape(dataURI.split(",")[1]);

    // separate out the mime component
    var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];

    // write the bytes of the string to a typed array
    var ia = new Uint8Array(byteString.length);
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    return new Blob([ia], { type: mimeString });
  }

  componentDidMount() {
    if (this.props.location.state && this.props.location.state.redirect) {
      this.setState({
        phoneOtpVerified: true,
        redirect: this.props.location.state.redirect,
        adult: {
          firstName: this.props.location.state.firstName,
          lastName: this.props.location.state.lastName,
          phone: this.props.location.state.phone,
        },
      });
      this.getEvents(
        this.props.location.state.SPIParentCamp,
        this.props.location.state.eventId
      );
    } else {
      let parentEvent = this.props.location.pathname
        .split("/")
        .filter((path) => path !== "");
      let params = GeneralFunctions.getQueryStringParams(
        this.props.location.search
      );
      this.getEvents(parentEvent[parentEvent.length - 1], params.eventId);
    }
  }

  getEvents = async (parentEventName, eventId) => {
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "rushsoccer/open/rushNational/camps",
        method: "GET",
      });
      if (response) {
        let camp = response.camps.find((camp) => camp.name === parentEventName);
        this.setState(
          {
            showLoader: false,
            camps: response.camps,
            selectedEventForAPI: camp
              ? {
                  value: camp._id,
                  label: camp.name,
                }
              : {
                  value: "-",
                  label: "-",
                },
            eventId,
          },
          () => this.getEventDetail()
        );
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  getEventDetail = async () => {
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "rushsoccer/camp/detail",
        method: "POST",
        data: {
          eventId: this.state.eventId,
        },
      });
      if (response) {
        let eventExpired = false;
        // if (response.camp.endingAt) {
        //   let currentDate = new Date().getTime();
        //   let campEndingDate = new Date(response.camp.endingAt).setHours(23, 59, 59, 999);
        //   campEndingDate = new Date(campEndingDate).getTime();
        //   if (currentDate > campEndingDate) {
        //     eventExpired = true;
        //   }
        // }
        this.setState(
          {
            eventExpired,
            showLoader: false,
            event: response.camp,
            codeVerified: response.camp.addCode ? false : true,
            showCashPaymentButton: response.camp.acceptCashPayment,
          },
          () => this.getRegistrationForm(response.camp ? response.camp : {})
        );
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  getProcessingFees = async () => {
    try {
      this.setState({ showLoader: true });
      let quantity = 0;
      if (this.state.event.teamRegistration) {
        quantity = this.state.teamQuantity;
      } else {
        if (this.state.event.addQuantity) {
          quantity = this.state.player.playerQuantity || 0;
        } else {
          quantity = 0;
        }
      }
      let response = await Server.request({
        url: "rushsoccer/processingFee",
        method: "POST",
        data: {
          SPIEvent: true,
          childId: this.state.newChildId || this.state.selectedChild.value,
          campId: this.state.eventId,
          quantity: Number(quantity),
          couponCode: this.state.validCode ? this.state.couponCode : null,
        },
      });
      if (response) {
        this.setState({
          showLoader: false,
          eventPriceDetails: response,
        });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  getRegistrationForm = async (camp) => {
    try {
      this.setState({ showLoader: true });
      if (camp.registerForm) {
        let allFields = camp.registerForm.reduce(
          (previousValue, currentValue) => {
            previousValue.push(...currentValue.fields);
            return previousValue;
          },
          []
        );
        allFields = this.state.event.addQuantity
          ? allFields
          : allFields.filter(
              (allField) =>
                allField._id !== "584f8f03-d257-4cf7-b440-9a2a7d730ea3"
            );
        let playerFields = allFields.filter(
          (form) =>
            form.for.value === "player" &&
            form.inputType !== "fileupload" && //remove fileuploads
            form._id !== "2e3b1830-6147-4955-a3b3-b8e3a2db3d14"
        );
        let adultFields = allFields
          .filter(
            (form) =>
              form.for.value === "adult" && form.inputType !== "fileupload" //remove fileuploads
          )
          .map((field) =>
            field.keyName === "photo"
              ? Object.assign(field, { keyName: "photo1" })
              : field
          );
        if (camp.teamRegistration) {
          adultFields = adultFields.filter(
            (adultField) =>
              adultField._id !== "6fbde57e-400e-48fc-8324-2af2821f367d"
          );
        }
        let wavierFormFieldsAdult = allFields.filter(
          (form) => form.for.value === "adult" && form.inputType === "waviers"
        );
        let wavierFormFieldsPlayers = allFields.filter(
          (form) => form.for.value === "player" && form.inputType === "waviers"
        );
        this.setState({
          showLoader: false,
          clubId: camp.clubId,
          registerFormFieldsAdult: adultFields,
          registerFormFieldsPlayers: playerFields,
          multiplePlayers: [{ registerFormFieldsPlayers: playerFields }],
          multipleAdults: [{ registerFormFieldsAdult: adultFields }],
          wavierFormFieldsAdult,
          wavierFormFieldsPlayers,
        });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  updateState = async (type, key, value) => {
    if (value === "on") {
      switch (type) {
        case "adult":
          value = !this.state.adult[key];
          break;
        case "player":
          value = !this.state.player[key];
          break;
        default:
          break;
      }
    }
    if (key === "phone" || key === "playerPhone") {
      if (value.length > 10) {
        return true;
      }
    }
    let multiplePlayers = this.state.multiplePlayers.length
      ? this.state.multiplePlayers
      : [
          {
            registerFormFieldsPlayers: cloneDeep(
              this.state.registerFormFieldsPlayers
            ),
          },
        ];
    if (type === "player" && key === "playerQuantity") {
      multiplePlayers = [];
      for (let index = 0; index < Number(value); index++) {
        let registerFormFieldsPlayers;
        if (index === 0) {
          registerFormFieldsPlayers = cloneDeep(
            this.state.registerFormFieldsPlayers
          );
        } else {
          registerFormFieldsPlayers = cloneDeep(
            this.state.registerFormFieldsPlayers
          );
          registerFormFieldsPlayers = registerFormFieldsPlayers
            .filter(
              (registerFormFieldsPlayer) =>
                registerFormFieldsPlayer.keyName !== "playerQuantity"
            )
            .map((registerFormFieldsPlayer) =>
              Object.assign(registerFormFieldsPlayer, {
                keyName: `${registerFormFieldsPlayer.keyName}${index + 1}`,
              })
            );
        }
        multiplePlayers.push({ registerFormFieldsPlayers });
      }
    }
    switch (type) {
      case "adult":
        this.setState((prevState) => ({
          adult: {
            ...prevState.adult,
            [key]: value,
          },
        }));
        break;
      case "player":
        this.setState((prevState) => ({
          multiplePlayers,
          player: {
            ...prevState.player,
            [key]: value,
          },
        }));
        break;
      default:
        break;
    }
  };

  onSubmit = async (event) => {
    event.preventDefault();
    try {
      let formData = new FormData();
      this.setState({ showLoader: true });
      if (this.state.registerFor === "parent") {
        if (!this.state.phoneOtpVerified || !this.state.emailOtpVerified) {
          throw Error("Verify email and phone first");
        }
        let adultFileFields = this.state.registerFormFieldsAdult.filter(
          (field) => field.inputType === "dropdown"
        );
        for (let index = 0; index < adultFileFields.length; index++) {
          const adultFileField = adultFileFields[index];
          if (adultFileField.required) {
            if (!this.state.adult[adultFileField.keyName]) {
              throw Error(`Select the ${adultFileField.placeholder}`);
            }
          }
        }
        if (this.state.event.teamRegistration && !this.state.teamQuantity) {
          throw Error("Select the team quantity");
        }
        let adultFileUploadFields = this.state.registerFormFieldsAdult
          .filter((field) => field.inputType === "fileupload")
          .map((field) => Object.assign(field, { for: "adult" }));
        for (let index = 0; index < adultFileUploadFields.length; index++) {
          const adultFileUploadField = adultFileUploadFields[index];
          if (adultFileUploadField.required) {
            if (this.state.adult[adultFileUploadField.keyName]) {
              formData.append(
                [adultFileUploadField.keyName],
                this.state.adult[adultFileUploadField.keyName]
              );
            } else {
              // throw Error(`Select the ${adultFileUploadField.placeholder}`);
              // let blob = this.dataURItoBlob(DefaultImage);
              // formData.append(
              //   [adultFileUploadField.keyName],
              //   blob,
              //   "defaultUser.png"
              // );
            }
          } else {
            if (this.state.adult[adultFileUploadField.keyName])
              formData.append(
                [adultFileUploadField.keyName],
                this.state.adult[adultFileUploadField.keyName]
              );
          }
        }
        if (this.state.submitType === "registerAdult") {
          formData.append("clubId", this.state.clubId);
          let adultObject = cloneDeep(this.state.adult);
          if (this.state.event.teamRegistration && this.state.teamQuantity) {
            Object.assign(adultObject, {
              teamQuantity: this.state.teamQuantity,
            });
          }
          formData.append("adult", JSON.stringify(adultObject));
          formData.append("registerFor", "parent");
          formData.append(
            "parentEventId",
            this.state.selectedEventForAPI.value
          );
          formData.append(
            "parentEventName",
            this.state.selectedEventForAPI.label
          );
          formData.append("SPIEventId", this.state.eventId);
          formData.append("SPIEventName", this.state.event.name);
          let deleteKeys = adultFileUploadFields.map((fields) => ({
            keyName: fields.keyName,
            for: fields.for,
          }));
          if (deleteKeys && deleteKeys.length)
            formData.append("deleteKeys", JSON.stringify(deleteKeys));
          let response = await Server.staticTokenServerRequest(
            {
              url: "rushUser/register/event",
              method: "POST",
              data: formData,
            },
            false
          );
          if (response) {
            if (response.success) {
              if (
                response.user.child.length &&
                !this.state.event.teamRegistration
              ) {
                response.user.child = response.user.child.filter(
                  (kid) => !kid.systemGenerated
                );
              }
              this.setState(
                {
                  showPaymentPage: this.state.event.teamRegistration,
                  selectedTabIndex: 1,
                  showLoader: false,
                  disabledFields: true,
                  registerChild: true,
                  parentId: response.user._id,
                  adult: response.user.data,
                  childs: response.user.child.length ? response.user.child : [],
                  selectedChild: response.user.child.length
                    ? {
                        value: response.user.child[0]._id,
                        label: `${response.user.child[0].data.firstName} ${response.user.child[0].data.lastName}`,
                      }
                    : {},
                  player: response.user.child.length
                    ? response.user.child[0].data
                    : {},
                  registerNewChild: response.user.child.length ? false : true,
                  stripeCards:
                    response.user.stripeCards &&
                    response.user.stripeCards.length
                      ? response.user.stripeCards
                      : [],
                  selectedCard:
                    response.user.stripeCards &&
                    response.user.stripeCards.length
                      ? response.user.stripeCards[0]
                      : {},
                },
                () => {
                  let player = this.state.childs.find(
                    (child) => child._id === this.state.selectedChild.value
                  );
                  // let multiplePlayers = this.state.multiplePlayers.length
                  //   ? this.state.multiplePlayers
                  //   : [
                  //     {
                  //       registerFormFieldsPlayers: cloneDeep(
                  //         this.state.registerFormFieldsPlayers
                  //       ),
                  //     },
                  //   ];
                  // if (player && player.data.playerQuantity > 0) {
                  //   multiplePlayers = [];
                  //   for (
                  //     let index = 0;
                  //     index < Number(player.data.playerQuantity);
                  //     index++
                  //   ) {
                  //     let registerFormFieldsPlayers;
                  //     if (index === 0) {
                  //       registerFormFieldsPlayers = cloneDeep(
                  //         this.state.registerFormFieldsPlayers
                  //       );
                  //     } else {
                  //       registerFormFieldsPlayers = cloneDeep(
                  //         this.state.registerFormFieldsPlayers
                  //       );
                  //       registerFormFieldsPlayers = registerFormFieldsPlayers
                  //         .filter(
                  //           (registerFormFieldsPlayer) =>
                  //             registerFormFieldsPlayer.keyName !==
                  //             "playerQuantity"
                  //         )
                  //         .map((registerFormFieldsPlayer) =>
                  //           Object.assign(registerFormFieldsPlayer, {
                  //             keyName: `${registerFormFieldsPlayer.keyName}${index + 1
                  //               }`,
                  //           })
                  //         );
                  //     }
                  //     multiplePlayers.push({ registerFormFieldsPlayers });
                  //   }
                  // }
                  if (player && player.data.playerQuantity) {
                    player.data.playerQuantity = "1";
                  }
                  this.setState({
                    multiplePlayers: [
                      {
                        registerFormFieldsPlayers: cloneDeep(
                          this.state.registerFormFieldsPlayers
                        ),
                      },
                    ],
                  });
                  this.state.event.teamRegistration && this.getProcessingFees();
                }
              );
              this.toggleVerificationModal();
              this.notificationSystem.addNotification({
                message: response.message,
                level: "success",
              });
            }
          }
          window.scrollTo(0, 0);
        } else {
          this.setState({ showLoader: false });
          this.toggleVerificationModal();
        }
      } else {
        if (!this.state.phoneOtpVerified || !this.state.emailOtpVerified) {
          throw Error("Verify email and phone first");
        }
        let playerFileFields = this.state.registerFormFieldsPlayers.filter(
          (field) => field.inputType === "dropdown"
        );
        for (let index = 0; index < playerFileFields.length; index++) {
          const playerFileField = playerFileFields[index];
          if (playerFileField.required) {
            if (!this.state.player[playerFileField.keyName]) {
              throw Error(`Select the ${playerFileField.placeholder}`);
            }
          }
        }
        let playerFileUploadFields = this.state.registerFormFieldsPlayers
          .filter((field) => field.inputType === "fileupload")
          .map((field) => Object.assign(field, { for: "player" }));
        for (let index = 0; index < playerFileUploadFields.length; index++) {
          const playerFileUploadField = playerFileUploadFields[index];
          if (playerFileUploadField.required) {
            if (this.state.player[playerFileUploadField.keyName]) {
              formData.append(
                [playerFileUploadField.keyName],
                this.state.player[playerFileUploadField.keyName]
              );
            } else {
              // throw Error(`Select the ${playerFileUploadField.placeholder}`);
              // let blob = this.dataURItoBlob(DefaultImage);
              // formData.append(
              //   [playerFileUploadField.keyName],
              //   blob,
              //   "defaultUser.png"
              // );
            }
          } else {
            if (this.state.player[playerFileUploadField.keyName])
              formData.append(
                [playerFileUploadField.keyName],
                this.state.player[playerFileUploadField.keyName]
              );
          }
        }
        if (this.state.submitType === "registerChild") {
          formData.append("clubId", this.state.clubId);
          if (!this.state.registerNewChild)
            formData.append("childId", this.state.selectedChild.value);
          formData.append("parentId", this.state.parentId);
          this.state.player["SPIEventId"] = this.state.eventId;
          this.state.player["SPIEventName"] = this.state.event.name || "";
          this.state.player[
            "parentEventId"
          ] = this.state.selectedEventForAPI.value;
          this.state.player[
            "parentEventName"
          ] = this.state.selectedEventForAPI.label;
          formData.append("player", JSON.stringify(this.state.player));
          formData.append("registerFor", "child");
          formData.append(
            "parentEventId",
            this.state.selectedEventForAPI.value
          );
          formData.append(
            "parentEventName",
            this.state.selectedEventForAPI.label
          );
          formData.append("SPIEventId", this.state.eventId);
          formData.append("SPIEventName", this.state.event.name);
          let deleteKeys = playerFileUploadFields.map((fields) => ({
            keyName: fields.keyName,
            for: fields.for,
          }));
          if (deleteKeys && deleteKeys.length)
            formData.append("deleteKeys", JSON.stringify(deleteKeys));
          let response = await Server.staticTokenServerRequest(
            {
              url: "rushUser/register/event",
              method: "POST",
              data: formData,
            },
            false
          );
          if (response) {
            if (response.success) {
              if (
                response.user.child.length &&
                !this.state.event.teamRegistration
              ) {
                response.user.child = response.user.child.filter(
                  (kid) => !kid.systemGenerated
                );
              }
              this.setState(
                {
                  showLoader: false,
                  showPayButton: true,
                  showPaymentPage: true,
                  playerDisabledFields: true,
                  adult: response.user.data,
                  childs: response.user.child.length ? response.user.child : [],
                  // selectedChild: response.user.child.length
                  //   ? {
                  //     value: response.user.child[0]._id,
                  //     label: `${response.user.child[0].data.firstName} ${response.user.child[0].data.lastName}`,
                  //   }
                  //   : {},
                  // player: response.user.child.length
                  //   ? response.user.child[0].data
                  //   : {},
                  stripeCards:
                    response.user.stripeCards &&
                    response.user.stripeCards.length
                      ? response.user.stripeCards
                      : [],
                  selectedCard:
                    response.user.stripeCards &&
                    response.user.stripeCards.length
                      ? response.user.stripeCards[0]
                      : {},
                  newChildId: response.newChildId,
                },
                () => this.getProcessingFees()
              );
              if (this.state.registerNewChild) {
                let child = response.user.child.find(
                  (child) => child._id === response.newChildId
                );
                this.setState({
                  selectedChild: {
                    value: child._id,
                    label: `${child.data.firstName} ${child.data.lastName}`,
                  },
                  player: child.data,
                });
              }
              this.toggleVerificationModal();
              this.notificationSystem.addNotification({
                message: response.message,
                level: "success",
              });
            }
          }
          window.scrollTo(0, 0);
        } else {
          this.setState({ showLoader: false });
          this.toggleVerificationModal();
        }
      }
    } catch (error) {
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
      this.setState({
        showLoader: false,
      });
    }
  };

  handleChange = async (type, key, event) => {
    const fileUploaded = event.target.files[0];
    switch (type) {
      case "adult":
        this.setState((prevState) => ({
          adult: {
            ...prevState.adult,
            [key]: fileUploaded,
            [`${key}FileName`]: fileUploaded.name,
          },
        }));
        break;
      case "player":
        this.setState((prevState) => ({
          player: {
            ...prevState.player,
            [key]: fileUploaded,
            [`${key}FileName`]: fileUploaded.name,
          },
        }));
        break;
      default:
        break;
    }
    event.target.value = null;
  };

  payForEvent = async (event) => {
    event.preventDefault();
    try {
      this.setState({ showLoader: true });
      let response;
      let quantity = 0;
      if (this.state.event.teamRegistration) {
        quantity = this.state.teamQuantity;
      } else {
        if (this.state.event.addQuantity) {
          quantity = this.state.player.playerQuantity || 0;
        } else {
          quantity = 0;
        }
      }
      if (this.state.cashPayment) {
        response = await Server.request({
          url: "rushsoccer/v1/player/payForEvent",
          method: "POST",
          data: {
            note: this.state.note || "Cash Payment",
            fullPayment: this.state.fullPayment,
            campId: this.state.eventId,
            installments: this.state.installments,
            parentId: this.state.parentId,
            childId: this.state.registerNewChild
              ? this.state.newChildId
              : this.state.selectedChild.value,
            installmentDates: this.state.installmentDates,
            installmentDateShow: !this.state.fullPayment,
            quantity: Number(quantity),
            couponCode: this.state.validCode ? this.state.couponCode : null,
            paymentDoneFrom: "web",
          },
        });
      } else {
        if (this.state.fullPayment) {
          response = await Server.request({
            url: "rushsoccer/stripe/pay",
            method: "POST",
            data: {
              SPIEvent: true,
              sendEmail: true,
              APIVersion: "v2",
              paymentFor: "child",
              paymentMethodId: this.state.selectedCard.paymentMethodId,
              campId: this.state.eventId,
              parentId: this.state.parentId,
              childId: this.state.registerNewChild
                ? this.state.newChildId
                : this.state.selectedChild.value,
              quantity: Number(quantity),
              couponCode: this.state.validCode ? this.state.couponCode : null,
              paymentDoneFrom: "web",
            },
          });
        } else {
          response = await Server.request({
            url: "rushsoccer/stripe/interval/pay",
            method: "POST",
            data: {
              SPIEvent: true,
              sendEmail: true,
              APIVersion: "v2",
              interval: "month",
              paymentFor: "child",
              paymentMethodId: this.state.selectedCard.paymentMethodId,
              campId: this.state.eventId,
              parentId: this.state.parentId,
              childId: this.state.registerNewChild
                ? this.state.newChildId
                : this.state.selectedChild.value,
              quantity: Number(quantity),
              couponCode: this.state.validCode ? this.state.couponCode : null,
              paymentDoneFrom: "web",
            },
          });
        }
      }
      if (response) {
        this.setState({
          showLoader: false,
          stripeCards: [],
          selectedCard: {},
          selectedChild: {},
          adult: {},
          player: {},
          disabledFields: false,
          playerDisabledFields: false,
          registerChild: false,
          showPayButton: false,
          registerFor: "parent",
          registerNewChild: false,
          newChildId: "",
          showPaymentPage: false,
          cvc: "",
          name: "",
          number: "",
          expiry: "",
          cardType: "",
          focus: "number",
          closeAlert: true,
          phoneOtp: "",
          phoneOtpSent: false,
          phoneOtpVerified: false,
          emailOtp: "",
          emailOtpSent: false,
          emailOtpVerified: false,
          paymentSuccessConfirmationModal: true,
          paymentSuccessMessage: response.message,
          fullPayment: true,
          selectedTabIndex: 0,
          cashPayment: false,
          installments: 0,
          installmentDates: [],
          note: "",
          teamQuantity: 0,
          multipleAdults: [
            { registerFormFieldsAdult: this.state.registerFormFieldsAdult },
          ],
          couponCode: "",
          invalidCode: false,
          validCode: false,
        });
        window.scrollTo(0, 0);
        this.togglePaymentConfirmationModal();
        let interval = setTimeout(
          () =>
            this.setState(
              {
                closeAlert: false,
                paymentSuccessMessage: "",
              },
              () => clearTimeout(interval)
            ),
          5000
        );
        if (this.state.redirect) {
          window.location.assign(`${window.location.origin}/parentlist`);
        }
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  addCreditCard = async (event) => {
    event.preventDefault();
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "rushsoccer/addPaymentMethod",
        method: "POST",
        data: {
          type: "card",
          APIVersion: "v2",
          parentId: this.state.parentId,
          cvc: this.state.cvc,
          number: this.state.number,
          exp_year: this.state.expiry.length
            ? this.state.expiry.substring(2, 4)
            : "",
          exp_month: this.state.expiry.length
            ? this.state.expiry.substring(0, 2)
            : "",
          cardType: this.state.cardType,
          parentEventName: this.state.selectedEventForAPI.label,
          eventName: this.state.event.name,
        },
      });
      if (response) {
        this.setState({
          showLoader: false,
          stripeCards:
            response.user.stripeCards && response.user.stripeCards.length
              ? response.user.stripeCards
              : [],
          selectedCard:
            response.user.stripeCards && response.user.stripeCards.length
              ? response.user.stripeCards[0]
              : {},
          cvc: "",
          name: "",
          number: "",
          expiry: "",
          cardType: "",
          focus: "number",
        });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  removeCoupon = async () => {
    this.setState(
      {
        invalidCode: false,
        validCode: false,
        couponCode: "",
        coupon: {},
      },
      () => this.getProcessingFees()
    );
  };

  applyCoupon = async () => {
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "rushsoccer/verify/discountCode",
        method: "POST",
        data: {
          campId: this.state.eventId,
          couponCode: this.state.couponCode,
        },
      });
      if (response) {
        this.setState(
          {
            showLoader: false,
            invalidCode: false,
            validCode: true,
            coupon: response.coupon,
          },
          () => this.getProcessingFees()
        );
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
      }
    } catch (error) {
      this.setState({
        showLoader: false,
        invalidCode: true,
        validCode: false,
      });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  sendOTP = async (event, sendOTPON) => {
    event.preventDefault();
    try {
      this.setState({ showLoader: true });
      let data = {
        sendOn: sendOTPON,
      };
      let setState = {
        showLoader: false,
      };
      switch (sendOTPON) {
        case "email":
          Object.assign(data, {
            email: this.state.adult.email,
          });
          Object.assign(setState, {
            emailOtpSent: true,
          });
          break;
        case "phone":
          Object.assign(data, {
            phone: `+1${this.state.adult.phone}`,
            username: `1${this.state.adult.phone}`,
          });
          Object.assign(setState, {
            phoneOtpSent: true,
          });
          break;
        default:
          break;
      }
      let response = await Server.staticTokenServerRequest(
        {
          url: "rushUser/createOTP",
          method: "POST",
          data,
        },
        true
      );
      if (response) {
        this.setState(setState);
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  verifyOTP = async (event, verifyOTPFor) => {
    event.preventDefault();
    try {
      this.setState({ showLoader: true });
      let data = {
        verifyFor: verifyOTPFor,
      };
      let setState = {
        showLoader: false,
      };
      switch (verifyOTPFor) {
        case "email":
          Object.assign(data, {
            otp: this.state.emailOtp,
            email: this.state.adult.email,
          });
          Object.assign(setState, {
            emailOtpVerified: true,
          });
          break;
        case "phone":
          Object.assign(data, {
            otp: this.state.phoneOtp,
            phone: `+1${this.state.adult.phone}`,
            username: `1${this.state.adult.phone}`,
          });
          Object.assign(setState, {
            phoneOtpVerified: true,
          });
          break;
        default:
          break;
      }
      let response = await Server.staticTokenServerRequest(
        {
          url: "rushUser/verifyOTP",
          method: "POST",
          data,
        },
        true
      );
      if (response && response.success) {
        this.setState(setState);
      } else {
        this.setState({
          showLoader: false,
        });
        this.notificationSystem.addNotification({
          message: response.message,
          level: "error",
        });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  verifyCode = async (event) => {
    event.preventDefault();
    try {
      this.setState({ showLoader: true });
      let response = await Server.staticTokenServerRequest(
        {
          url: "rushUser/verify/SPICode",
          method: "POST",
          data: {
            code: Number(this.state.code),
            parentEventId: this.state.selectedEventForAPI.value,
            eventId: this.state.eventId,
          },
        },
        false
      );
      if (response) {
        this.setState({
          showLoader: false,
          code: "",
          codeVerified: true,
          closeAlert: true,
          paymentSuccessMessage: response.message,
        });
      }
      let interval = setTimeout(
        () =>
          this.setState(
            {
              closeAlert: false,
              paymentSuccessMessage: "",
            },
            () => clearTimeout(interval)
          ),
        5000
      );
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  getImageUrl = (keyName, type) => {
    let imageUrl;
    switch (type) {
      case "adult":
        if (keyName === "photo1") {
          let file = this.state.adult.files.find(
            (file) => file.name === "photo"
          );
          imageUrl = file.url;
        } else {
          let file = this.state.adult.files.find(
            (file) => file.name === keyName
          );
          imageUrl = file.url;
        }
        break;
      case "player":
        let file = this.state.player.files.find(
          (file) => file.name === keyName
        );
        imageUrl = file.url;
        break;
      default:
        break;
    }
    return imageUrl;
  };

  installmentDates = (key) => {
    let dates =
      this.state.installmentDates.length > 0 ? this.state.installmentDates : [];
    if (key === "add") {
      if (this.state.installmentDates.length !== this.state.installments) {
        let Start =
          this.state.installmentDates.length === 0
            ? 1
            : this.state.installmentDates.length + 1;
        for (let index = Start; index <= this.state.installments; index++) {
          dates.push({ price: 0, date: "", installmentNumber: index });
        }
      }
    } else if (key === "remove") {
      for (
        let index1 = this.state.installments + 1;
        index1 <= this.state.installmentDates.length;
        index1++
      ) {
        dates = dates.filter((date) => date.installmentNumber !== index1);
      }
    }
    this.setState({ installmentDates: dates });
  };

  formatCreditCardNumber = (number) =>
    `**** **** **** ${
      number ? number.substr(number.length - 4, number.length) : "****"
    }`;

  getChildNames = () => {
    if (this.state.player.playerQuantity) {
      let names = [];
      for (
        let index = 0;
        index < Number(this.state.player.playerQuantity);
        index++
      ) {
        if (index === 0) {
          names.push(
            `${this.state.player.firstName} ${this.state.player.lastName}`
          );
        } else {
          let firstName = this.state.player[`firstName${index + 1}`];
          let lastName = this.state.player[`lastName${index + 1}`];
          if (firstName && lastName) {
            names.push(`${firstName} ${lastName}`);
          }
        }
      }
      if (Number(this.state.player.playerQuantity) > 3) {
        childNameTextAreaStyle = { height: "100px" };
      }
      return names.length ? names.join(", ") : "";
    } else {
      return this.state.player.firstName
        ? `${this.state.player.firstName} ${this.state.player.lastName}`
        : "";
    }
  };

  toggleVerificationModal = () => {
    this.setState({
      verificationModal: !this.state.verificationModal,
    });
  };

  togglePaymentConfirmationModal = () => {
    this.setState({
      paymentConfirmationModal: !this.state.paymentConfirmationModal,
    });
  };

  togglePaymentSuccessConfirmationModal = () => {
    this.setState({
      paymentSuccessConfirmationModal: !this.state
        .paymentSuccessConfirmationModal,
    });
  };

  render() {
    return (
      <Fragment>
        <Navbar
          light
          expand
          className={bem.b("#17517B")}
          style={{
            backgroundColor: "#17517B",
            borderBottom: 0,
            marginBottom: 0,
          }}
        >
          <div
            style={{
              color: "white",
              margin: "auto",
            }}
          >
            <h1
              style={{
                margin: "auto",
                fontWeight: "bold",
              }}
            >
              Rush National Program
            </h1>
          </div>
        </Navbar>
        {this.state.showPaymentPage ? (
          <Container>
            <PageSpinner showLoader={this.state.showLoader} />
            <div
              className="login-form"
              style={{
                margin: "20px 0px",
                maxWidth: "unset",
              }}
            >
              <Col
                style={{
                  borderBottom: "3px solid #e4e5e6",
                  marginBottom: "10px",
                }}
              >
                <h2>Payment for event</h2>
              </Col>
              <Row style={{ padding: "0px 15px" }}>
                <Col xl={6} lg={6} md={12} sm={12}>
                  <Label>SPI Event</Label>
                  <FormGroup>
                    <Input
                      disabled
                      value={
                        this.state.selectedEventForAPI.label
                          ? this.state.selectedEventForAPI.label
                          : ""
                      }
                    />
                  </FormGroup>
                </Col>
                <Col xl={6} lg={6} md={12} sm={12}>
                  <Label>Event</Label>
                  <FormGroup>
                    <Input
                      disabled
                      value={this.state.event.name ? this.state.event.name : ""}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row style={{ padding: "0px 15px" }}>
                <Col xl={6} lg={6} md={12} sm={12}>
                  <Label>Parent Name</Label>
                  <FormGroup>
                    <Input
                      disabled
                      value={
                        this.state.adult.firstName
                          ? `${this.state.adult.firstName} ${this.state.adult.lastName}`
                          : ""
                      }
                    />
                  </FormGroup>
                </Col>
                <Col xl={6} lg={6} md={12} sm={12}>
                  <Label>Child Name</Label>
                  <FormGroup>
                    <Input
                      style={childNameTextAreaStyle}
                      type="textarea"
                      disabled
                      value={this.getChildNames()}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Col
                style={{
                  borderTop: "3px solid #e4e5e6",
                  borderBottom: "3px solid #e4e5e6",
                  marginBottom: "10px",
                  paddingTop: "10px",
                }}
              >
                <h2>Add Credit Card</h2>
              </Col>
              <Form className="form" onSubmit={this.addCreditCard}>
                <Row style={{ padding: "0px 15px" }}>
                  <Col style={{ margin: "auto" }} xl={6} lg={6} md={12} sm={12}>
                    <Cards
                      cvc={this.state.cvc}
                      expiry={this.state.expiry}
                      focused={this.state.focus}
                      name={this.state.name}
                      number={this.state.number}
                      callback={(event) => {
                        this.setState({ cardType: event.issuer });
                      }}
                    />
                  </Col>
                  <Col className="mt-3" xl={6} lg={6} md={12} sm={12}>
                    <>
                      <Label>Card Number</Label>
                      <FormGroup>
                        <Input
                          id="number"
                          name="number"
                          type="text"
                          maxLength="16"
                          value={this.state.number}
                          onChange={(event) =>
                            this.setState({
                              number: event.target.value,
                              focus: "number",
                            })
                          }
                          placeholder="CARD NUMBER"
                          required
                        />
                      </FormGroup>
                    </>
                    <>
                      <Label>Card Name</Label>
                      <FormGroup>
                        <Input
                          id="name"
                          name="name"
                          type="text"
                          value={this.state.name}
                          onChange={(event) =>
                            this.setState({
                              name: event.target.value,
                              focus: "name",
                            })
                          }
                          placeholder="CARD NAME"
                          required
                        />
                      </FormGroup>
                    </>
                    <Row>
                      <Col xl={6} lg={6} md={12} sm={12}>
                        <Label>Card Expiration Date</Label>
                        <FormGroup>
                          <Input
                            id="expiry"
                            name="expiry"
                            type="text"
                            maxLength="4"
                            value={this.state.expiry}
                            onChange={(event) =>
                              this.setState({
                                expiry: event.target.value,
                                focus: "expiry",
                              })
                            }
                            placeholder="MM/YY"
                            required
                          />
                        </FormGroup>
                      </Col>
                      <Col xl={6} lg={6} md={12} sm={12}>
                        <Label>CVC</Label>
                        <FormGroup>
                          <Input
                            id="cvc"
                            name="cvc"
                            type="text"
                            maxLength="4"
                            value={this.state.cvc}
                            onChange={(event) =>
                              this.setState({
                                cvc: event.target.value,
                                focus: "cvc",
                              })
                            }
                            placeholder="CVC"
                            required
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <>
                      <FormGroup>
                        <Button type="submit" onClick={() => {}}>
                          Add Credit Card
                        </Button>
                      </FormGroup>
                    </>
                  </Col>
                </Row>
              </Form>
              <Row>
                <Col>
                  <Table striped hover responsive>
                    <thead>
                      <tr>
                        <th className={"text-center"}>Select Card</th>
                        <th className={"text-center"}>Card Number</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.stripeCards.length ? (
                        this.state.stripeCards.map((card, index) => (
                          <tr key={index}>
                            <td className={"text-center"}>
                              <Input
                                type="checkbox"
                                style={{
                                  width: "20px",
                                  height: "20px",
                                  marginTop: "0px",
                                }}
                                onClick={() =>
                                  this.setState({ selectedCard: card })
                                }
                                checked={
                                  this.state.selectedCard._id === card._id
                                }
                              ></Input>
                            </td>
                            <td className={"text-center"}>
                              {card.number
                                ? this.formatCreditCardNumber(card.number)
                                : "-"}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="2" className="text-center">
                            No cards found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </Col>
              </Row>
              <Col
                style={{
                  padding: "5px 0px",
                  borderTop: "3px solid #e4e5e6",
                }}
              ></Col>
              <Col>
                <Table striped hover responsive>
                  <thead>
                    <tr>
                      <th colSpan="2" className={"text-center"}>
                        Event Details
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className={"text-center"}>Event Name</td>
                      <td className={"text-center"}>
                        {this.state.event.name ? this.state.event.name : "-"}
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{ verticalAlign: "middle !important" }}
                        className={"text-center width50"}
                      >
                        Discount Code
                      </td>
                      <td className="d-flex">
                        <div className="width100">
                          <Input
                            style={{ backgroundImage: "unset" }}
                            invalid={this.state.invalidCode}
                            valid={this.state.validCode}
                            disabled={this.state.validCode}
                            value={this.state.couponCode}
                            onChange={(event) =>
                              this.setState({
                                couponCode: event.target.value,
                                invalidCode: false,
                                validCode: false,
                              })
                            }
                          />
                          <FormFeedback>Invalid discount code</FormFeedback>
                          <FormFeedback valid>
                            Discount code applied
                          </FormFeedback>
                        </div>
                        <div>
                          {this.state.validCode ? (
                            <Button
                              className="ml-2"
                              onClick={() => this.removeCoupon()}
                            >
                              <MdDeleteForever size="20px"></MdDeleteForever>
                            </Button>
                          ) : (
                            <Button
                              className="ml-2"
                              onClick={() => this.applyCoupon()}
                            >
                              Apply
                            </Button>
                          )}
                        </div>
                      </td>
                    </tr>
                    {/* <tr>
                        <td className={"text-center"}>Price</td>
                        <td className={"text-center"}>{this.state.eventPriceDetails.fullPayment
                          ? (this.state.eventPriceDetails.fullPayment.price).toFixed(2)
                          : 0
                        }</td>
                      </tr>
                      <tr>
                        <td className={"text-center"}>Processing Fee</td>
                        <td className={"text-center"}>{this.state.eventPriceDetails.fullPayment
                          ? (this.state.eventPriceDetails.fullPayment.processingFee).toFixed(2)
                          : 0
                        }</td>
                      </tr> */}
                    {this.state.showCashPaymentButton ? (
                      <tr>
                        <td className={"text-center"}>
                          <CustomInput
                            id="cashPayment"
                            type="radio"
                            label="Cash Payment"
                            checked={this.state.cashPayment}
                            name="cashPayment"
                            onClick={() =>
                              this.setState({
                                cashPayment: true,
                              })
                            }
                          />
                        </td>
                        <td className={"text-center"}>
                          <CustomInput
                            id="cardPayment"
                            type="radio"
                            label="Card payment"
                            checked={!this.state.cashPayment}
                            name="cashPayment"
                            onClick={() =>
                              this.setState({
                                cashPayment: false,
                              })
                            }
                          />
                        </td>
                      </tr>
                    ) : null}
                    <tr>
                      <td className={"text-center"}>
                        <CustomInput
                          id="fullpayment"
                          type="radio"
                          label="Full Payment"
                          checked={this.state.fullPayment}
                          name="payment"
                          onClick={() =>
                            this.setState({
                              fullPayment: true,
                            })
                          }
                        />
                      </td>
                      <td className={"text-center"}>
                        <CustomInput
                          id="installmentpayment"
                          type="radio"
                          label="Installment payment"
                          checked={!this.state.fullPayment}
                          name="payment"
                          onClick={() =>
                            this.setState({
                              fullPayment: false,
                            })
                          }
                        />
                      </td>
                    </tr>
                    {this.state.cashPayment ? (
                      <tr>
                        <td
                          className={"text-center"}
                          style={{ verticalAlign: "center" }}
                        >
                          Note
                        </td>
                        <td className={"text-center"}>
                          <Input
                            type="text"
                            required
                            value={this.state.note}
                            onChange={(event) =>
                              this.setState({
                                note: event.target.value,
                              })
                            }
                          ></Input>
                        </td>
                      </tr>
                    ) : null}
                    {this.state.cashPayment ? (
                      this.state.fullPayment ? (
                        <tr>
                          <td className={"text-center"}>Total Price</td>
                          <td className={"text-center"}>
                            $
                            {this.state.eventPriceDetails.fullPayment
                              ? (
                                  this.state.eventPriceDetails.fullPayment
                                    .price -
                                  this.state.eventPriceDetails.fullPayment
                                    .discountPrice
                                ).toFixed(2)
                              : 0}
                          </td>
                        </tr>
                      ) : (
                        <>
                          <tr>
                            <td
                              className={"text-center"}
                              style={{ verticalAlign: "center" }}
                            >
                              Discount Price
                            </td>
                            <td className={"text-center"}>
                              <Input
                                disabled
                                value={
                                  this.state.coupon.price
                                    ? this.state.coupon.price.toFixed(2)
                                    : "0.00"
                                }
                              ></Input>
                            </td>
                          </tr>
                          <tr>
                            <td className={"text-center"}>
                              <Label for="installments">
                                Select Installments :
                              </Label>
                            </td>
                            <td className={"text-center"}>
                              <CustomInput
                                type="select"
                                id="installments"
                                name="selectInstallments"
                                defaultValue={"0"}
                                value={this.state.installments}
                                onChange={(event) => {
                                  event.persist();
                                  let key =
                                    event.target.value >
                                    parseInt(this.state.installments || 0)
                                      ? "add"
                                      : "remove";
                                  this.setState(
                                    {
                                      installments: Number(event.target.value),
                                    },
                                    () => this.installmentDates(key)
                                  );
                                }}
                              >
                                <option value="0" disabled>
                                  Select the value
                                </option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                                <option value="6">6</option>
                                <option value="7">7</option>
                                <option value="8">8</option>
                                <option value="9">9</option>
                                <option value="10">10</option>
                                <option value="11">11</option>
                              </CustomInput>
                            </td>
                          </tr>
                          {this.state.installmentDates &&
                          this.state.installmentDates.length > 0 ? (
                            <>
                              <tr>
                                <td className={"text-center"}>
                                  <Label>Installment Dates :</Label>
                                </td>
                                <td></td>
                              </tr>
                              {this.state.installmentDates.map(
                                (installmentDate, index) => (
                                  <tr key={index}>
                                    <td className={"text-center"}>
                                      {index === 0 ? (
                                        <Label>Initial Amount :</Label>
                                      ) : (
                                        <Label>Payment {index} :</Label>
                                      )}
                                    </td>
                                    {index === 0 ? (
                                      <td className={"text-center"}>
                                        <Input
                                          type="number"
                                          required={
                                            this.state.installmentDateShow
                                          }
                                          value={installmentDate.price}
                                          onChange={(event) => {
                                            if (
                                              event.target.value >= 0 &&
                                              event.target.value <=
                                                this.state.eventPriceDetails
                                                  .fullPayment.totalPrice
                                            ) {
                                              let installmentDates = cloneDeep(
                                                this.state.installmentDates
                                              );
                                              installmentDates[
                                                index
                                              ].price = Number(
                                                event.target.value
                                              );
                                              this.setState({
                                                installmentDates: installmentDates,
                                              });
                                            }
                                          }}
                                        ></Input>
                                      </td>
                                    ) : (
                                      <td className={"text-center"}>
                                        <Input
                                          type="date"
                                          value={
                                            moment(
                                              new Date(installmentDate.date)
                                            ).format("YYYY-MM-DD") || ""
                                          }
                                          onChange={(event) => {
                                            let dates = this.state
                                              .installmentDates;
                                            let date = new Date(
                                              event.target.value
                                            ).setUTCHours(12);
                                            dates[index].date = date;
                                            this.setState({
                                              installmentDates: dates,
                                            });
                                          }}
                                          required={
                                            this.state.installmentDateShow
                                          }
                                        ></Input>
                                      </td>
                                    )}
                                  </tr>
                                )
                              )}
                            </>
                          ) : null}
                        </>
                      )
                    ) : this.state.fullPayment ? (
                      <tr>
                        <td className={"text-center"}>Total Price</td>
                        <td className={"text-center"}>
                          $
                          {this.state.eventPriceDetails.fullPayment
                            ? this.state.eventPriceDetails.fullPayment.totalPrice.toFixed(
                                2
                              )
                            : 0}
                        </td>
                      </tr>
                    ) : this.state.eventPriceDetails.installments &&
                      this.state.eventPriceDetails.installments.length ? (
                      <tr>
                        <td colSpan="2">
                          <Table striped hover responsive>
                            <thead>
                              <tr>
                                <th className={"text-center"}>
                                  Installment Number
                                </th>
                                <th className={"text-center"}>Price</th>
                                <th className={"text-center"}>Due Date</th>
                              </tr>
                            </thead>
                            <tbody>
                              {this.state.eventPriceDetails.installments.map(
                                (installment, index) => (
                                  <tr key={index}>
                                    <td className={"text-center"}>
                                      {installment.installmentNumber
                                        ? installment.installmentNumber
                                        : "-"}
                                    </td>
                                    <td className={"text-center"}>
                                      $
                                      {installment.totalPrice
                                        ? installment.totalPrice.toFixed(2)
                                        : "0.00"}
                                    </td>
                                    <td className={"text-center"}>
                                      {installment.dueDate
                                        ? moment
                                            .utc(installment.dueDate)
                                            .format("LL")
                                        : "-"}
                                    </td>
                                  </tr>
                                )
                              )}
                            </tbody>
                          </Table>
                        </td>
                      </tr>
                    ) : (
                      <tr>
                        <td colSpan="2" className={"text-center"}>
                          No installment payment
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </Col>
              <Col
                style={{
                  padding: "5px 0px",
                  borderTop: "3px solid #e4e5e6",
                }}
              ></Col>
              <Col
                style={{
                  textAlign: "center",
                }}
              >
                <Button
                  disabled={
                    this.state.cashPayment
                      ? !this.state.fullPayment &&
                        (this.state.installmentDates &&
                        this.state.installmentDates.length
                          ? false
                          : true)
                      : !this.state.fullPayment &&
                        (this.state.eventPriceDetails.installments &&
                        this.state.eventPriceDetails.installments.length
                          ? false
                          : true)
                  }
                  type="submit"
                  className="ml-2"
                  onClick={() => this.togglePaymentConfirmationModal()}
                >
                  Pay
                </Button>
              </Col>
            </div>
            {this.state.paymentConfirmationModal ? (
              <Modal
                isOpen={this.state.paymentConfirmationModal}
                toggle={(event) => this.togglePaymentConfirmationModal()}
                className="modal-md"
              >
                <ModalHeader
                  style={{
                    background: "#f8f9fa",
                  }}
                  toggle={(event) => this.togglePaymentConfirmationModal()}
                >
                  Confirmantion
                </ModalHeader>
                <ModalBody
                  style={{
                    background: "#f8f9fa",
                  }}
                >
                  <Row>
                    <Col>
                      <FormGroup>
                        <Label>Are you sure you want to pay?</Label>
                      </FormGroup>
                    </Col>
                  </Row>
                </ModalBody>
                <ModalFooter
                  style={{
                    background: "#f8f9fa",
                  }}
                >
                  <Form className="form" onSubmit={this.payForEvent}>
                    <Button type="submit">Pay</Button>
                  </Form>
                  <Button onClick={() => this.togglePaymentConfirmationModal()}>
                    Cancel
                  </Button>{" "}
                </ModalFooter>
              </Modal>
            ) : null}
          </Container>
        ) : (
          <>
            {this.state.eventExpired ? (
              <Container>
                <div
                  className="login-form"
                  style={{
                    marginTop: "20px",
                    maxWidth: "unset",
                  }}
                >
                  <Col
                    style={{
                      textAlign: "center",
                      borderBottom: "3px solid #e4e5e6",
                      marginBottom: "10px",
                    }}
                  >
                    <h2>Event Expired</h2>
                  </Col>
                </div>
              </Container>
            ) : this.state.registerFormFieldsAdult.length &&
              this.state.registerFormFieldsPlayers.length ? (
              <Container>
                <PageSpinner showLoader={this.state.showLoader} />
                <div
                  className="login-form"
                  style={{
                    margin: "20px 0px",
                    maxWidth: "unset",
                  }}
                >
                  <Col
                    style={{
                      borderBottom: "3px solid #e4e5e6",
                      marginBottom: "10px",
                    }}
                  >
                    <h2>Registration Form</h2>
                  </Col>
                  <Col>
                    <Alert
                      color="success"
                      isOpen={this.state.closeAlert}
                      toggle={() => this.setState({ closeAlert: false })}
                    >
                      {this.state.paymentSuccessMessage}
                    </Alert>
                  </Col>
                  <Row
                    style={{
                      borderBottom: "3px solid #e4e5e6",
                      margin: "0px 0px 10px 0px",
                    }}
                  >
                    <Col xl={6} lg={6} md={12} sm={12}>
                      <FormGroup>
                        <Label>SPI Event</Label>
                        <Input
                          disabled
                          value={
                            this.state.selectedEventForAPI.label
                              ? this.state.selectedEventForAPI.label
                              : ""
                          }
                        />
                      </FormGroup>
                      {/* <FormGroup>
                          <Label for="name">Select Event :</Label>
                          <Select
                            isDisabled={this.state.disabledFields}
                            value={this.state.selectedEventForAPI}
                            options={[
                              ...this.state.camps.map((camp) => ({
                                value: camp._id,
                                label: camp.name,
                              })),
                            ]}
                            onChange={(result) => {
                              let camp = this.state.camps.find(
                                (camp) => camp._id === result.value
                              );
                              this.setState(
                                {
                                  selectedEventForAPI: result,
                                },
                                () => this.getRegistrationForm(camp)
                              );
                            }}
                          />
                        </FormGroup> */}
                    </Col>
                    <Col xl={6} lg={6} md={12} sm={12}>
                      <FormGroup>
                        <Label>Event</Label>
                        <Input
                          disabled
                          value={
                            this.state.event.name ? this.state.event.name : "-"
                          }
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  {this.state.codeVerified ? (
                    <Form className="form" onSubmit={this.onSubmit}>
                      <Tabs
                        style={{ width: "100%" }}
                        onSelect={(index) =>
                          this.setState({ selectedTabIndex: index })
                        }
                        selectedIndex={this.state.selectedTabIndex}
                      >
                        <TabList>
                          {this.state.event.teamRegistration ? (
                            <Tab>Register Team</Tab>
                          ) : (
                            <Tab>Register Parent</Tab>
                          )}
                          {this.state.registerChild && (
                            <Tab>Register Player</Tab>
                          )}
                        </TabList>
                        <TabPanel>
                          {this.state.event.teamRegistration ? (
                            <Tabs style={{ width: "100%" }}>
                              <TabList>
                                {this.state.multipleAdults.map(
                                  (multipleAdult, index) => (
                                    <Tab>Team {index + 1}</Tab>
                                  )
                                )}
                              </TabList>
                              {this.state.multipleAdults.map(
                                (multipleAdult, index) => (
                                  <TabPanel key={index}>
                                    {index === 0 &&
                                    this.state.event.teamRegistration ? (
                                      <Col>
                                        <FormGroup>
                                          <Label>
                                            How many registrations would you
                                            like to purchase?
                                            <span
                                              style={{
                                                color: "red",
                                                marginLeft: "5px",
                                              }}
                                            >
                                              *
                                            </span>
                                          </Label>
                                          <Input
                                            min="0"
                                            name={"teamQuantity"}
                                            type="select"
                                            value={
                                              this.state.teamQuantity ||
                                              "default"
                                            }
                                            onChange={(event) => {
                                              let multipleAdults = this.state
                                                .multipleAdults.length
                                                ? this.state.multipleAdults
                                                : [
                                                    {
                                                      registerFormFieldsAdult: cloneDeep(
                                                        this.state
                                                          .registerFormFieldsAdult
                                                      ),
                                                    },
                                                  ];
                                              if (event.target.value > 0) {
                                                multipleAdults = [];
                                                for (
                                                  let index = 0;
                                                  index <
                                                  Number(event.target.value);
                                                  index++
                                                ) {
                                                  let registerFormFieldsAdult;
                                                  if (index === 0) {
                                                    registerFormFieldsAdult = cloneDeep(
                                                      this.state
                                                        .registerFormFieldsAdult
                                                    );
                                                  } else {
                                                    registerFormFieldsAdult = cloneDeep(
                                                      this.state
                                                        .registerFormFieldsAdult
                                                    );
                                                    registerFormFieldsAdult = registerFormFieldsAdult.map(
                                                      (
                                                        registerFormFieldAdult
                                                      ) =>
                                                        Object.assign(
                                                          registerFormFieldAdult,
                                                          {
                                                            keyName: `${
                                                              registerFormFieldAdult.keyName
                                                            }${index + 1}`,
                                                          }
                                                        )
                                                    );
                                                  }
                                                  multipleAdults.push({
                                                    registerFormFieldsAdult,
                                                  });
                                                }
                                              }
                                              this.setState({
                                                multipleAdults,
                                                teamQuantity:
                                                  event.target.value,
                                              });
                                            }}
                                            required
                                          >
                                            <option value="default" disabled>
                                              Select the value
                                            </option>
                                            {this.state.teamQuantityValues
                                              .length &&
                                              this.state.teamQuantityValues.map(
                                                (value, index) => (
                                                  <option
                                                    key={index}
                                                    value={value}
                                                  >
                                                    {value}
                                                  </option>
                                                )
                                              )}
                                          </Input>
                                        </FormGroup>
                                      </Col>
                                    ) : null}
                                    {multipleAdult.registerFormFieldsAdult.map(
                                      (registerFormField, index) => (
                                        <Col key={index}>
                                          <FormGroup>
                                            {registerFormField.inputType ===
                                              "text" && (
                                              <>
                                                <Label>
                                                  {
                                                    registerFormField.placeholder
                                                  }
                                                  {registerFormField.required && (
                                                    <span
                                                      style={{
                                                        color: "red",
                                                        marginLeft: "5px",
                                                      }}
                                                    >
                                                      *
                                                    </span>
                                                  )}
                                                </Label>
                                                <div
                                                  style={{ display: "flex" }}
                                                >
                                                  <Input
                                                    disabled={
                                                      this.state
                                                        .disabledFields ||
                                                      registerFormField.keyName ===
                                                        "email"
                                                        ? this.state
                                                            .emailOtpVerified
                                                        : false
                                                    }
                                                    id={index}
                                                    name={
                                                      registerFormField.name
                                                    }
                                                    type="text"
                                                    value={
                                                      this.state.adult[
                                                        registerFormField
                                                          .keyName
                                                      ] || ""
                                                    }
                                                    onChange={(event) =>
                                                      this.updateState(
                                                        "adult",
                                                        registerFormField.keyName,
                                                        event.target.value
                                                      )
                                                    }
                                                    placeholder={
                                                      registerFormField.placeholder
                                                    }
                                                    required={
                                                      registerFormField.required
                                                    }
                                                  />
                                                  {registerFormField.keyName ===
                                                    "email" && (
                                                    <>
                                                      {this.state
                                                        .emailOtpVerified &&
                                                      !this.state
                                                        .disabledFields ? (
                                                        <>
                                                          <GoVerified
                                                            size="20px"
                                                            style={{
                                                              margin:
                                                                "auto auto auto 10px",
                                                              outline: " unset",
                                                              color: "green",
                                                            }}
                                                            id="verifiedEmailTooltip"
                                                            onMouseOver={() =>
                                                              this.setState({
                                                                verifiedEmailTooltip: true,
                                                              })
                                                            }
                                                            onMouseOut={() =>
                                                              this.setState({
                                                                verifiedEmailTooltip: false,
                                                              })
                                                            }
                                                          />
                                                          <MdEdit
                                                            size="20px"
                                                            style={{
                                                              cursor: "pointer",
                                                              margin:
                                                                "auto auto auto 10px",
                                                              outline: " unset",
                                                            }}
                                                            onClick={() =>
                                                              this.setState({
                                                                emailOtp: "",
                                                                emailOtpSent: false,
                                                                emailOtpVerified: false,
                                                              })
                                                            }
                                                          />
                                                          <Tooltip
                                                            placement="bottom"
                                                            isOpen={
                                                              this.state
                                                                .verifiedEmailTooltip
                                                            }
                                                            target="verifiedEmailTooltip"
                                                            toggle={() => {}}
                                                          >
                                                            Email Verified
                                                          </Tooltip>
                                                        </>
                                                      ) : !this.state
                                                          .disabledFields ? (
                                                        <>
                                                          <GoUnverified
                                                            size="20px"
                                                            id="unverifiedEmailTooltip"
                                                            style={{
                                                              margin:
                                                                "auto auto auto 10px",
                                                              outline: " unset",
                                                            }}
                                                            onMouseOver={() =>
                                                              this.setState({
                                                                unverifiedEmailTooltip: true,
                                                              })
                                                            }
                                                            onMouseOut={() =>
                                                              this.setState({
                                                                unverifiedEmailTooltip: false,
                                                              })
                                                            }
                                                          />
                                                          <Tooltip
                                                            placement="bottom"
                                                            isOpen={
                                                              this.state
                                                                .unverifiedEmailTooltip
                                                            }
                                                            target="unverifiedEmailTooltip"
                                                            toggle={() => {}}
                                                          >
                                                            Email Unverified
                                                          </Tooltip>
                                                        </>
                                                      ) : null}
                                                    </>
                                                  )}
                                                </div>
                                              </>
                                            )}
                                            {registerFormField.keyName ===
                                              "email" &&
                                              !this.state.emailOtpVerified &&
                                              this.state.adult[
                                                registerFormField.keyName
                                              ] && (
                                                <>
                                                  {this.state.emailOtpSent ? (
                                                    <>
                                                      <FormGroup className="mt-3">
                                                        <Label>
                                                          Verify Email
                                                        </Label>
                                                        <OtpInput
                                                          className="otpInput d-flex justify-content-center"
                                                          inputStyle={{
                                                            color: "#17517b",
                                                            width: "3rem",
                                                            height: "3rem",
                                                            margin: "0 1rem",
                                                            fontSize: "2rem",
                                                            borderRadius: "4px",
                                                            border:
                                                              "1px solid rgba(0,0,0,0.3)",
                                                            outlineColor:
                                                              "#17517b",
                                                          }}
                                                          // shouldAutoFocus={true}
                                                          isInputNum={true}
                                                          value={
                                                            this.state.emailOtp
                                                          }
                                                          onChange={(value) =>
                                                            this.setState({
                                                              emailOtp: value,
                                                            })
                                                          }
                                                          numInputs={4}
                                                          separator={
                                                            <span>-</span>
                                                          }
                                                        />
                                                      </FormGroup>
                                                      <Button
                                                        onClick={(event) =>
                                                          this.verifyOTP(
                                                            event,
                                                            "email"
                                                          )
                                                        }
                                                      >
                                                        Verify OTP
                                                      </Button>
                                                      <Button
                                                        className="ml-2"
                                                        onClick={(event) =>
                                                          this.sendOTP(
                                                            event,
                                                            "email"
                                                          )
                                                        }
                                                      >
                                                        Resend OTP
                                                      </Button>
                                                    </>
                                                  ) : (
                                                    <Button
                                                      className="mt-3"
                                                      onClick={(event) =>
                                                        this.sendOTP(
                                                          event,
                                                          "email"
                                                        )
                                                      }
                                                    >
                                                      Send OTP
                                                    </Button>
                                                  )}
                                                </>
                                              )}
                                            {registerFormField.inputType ===
                                              "number" && (
                                              <>
                                                <Label>
                                                  {
                                                    registerFormField.placeholder
                                                  }
                                                  {registerFormField.required && (
                                                    <span
                                                      style={{
                                                        color: "red",
                                                        marginLeft: "5px",
                                                      }}
                                                    >
                                                      *
                                                    </span>
                                                  )}
                                                </Label>
                                                <div
                                                  style={{ display: "flex" }}
                                                >
                                                  <Input
                                                    id={index}
                                                    disabled={
                                                      this.state
                                                        .disabledFields ||
                                                      registerFormField.keyName ===
                                                        "phone"
                                                        ? this.state
                                                            .phoneOtpVerified
                                                        : false
                                                    }
                                                    name={
                                                      registerFormField.name
                                                    }
                                                    type="number"
                                                    value={
                                                      this.state.adult[
                                                        registerFormField
                                                          .keyName
                                                      ] || ""
                                                    }
                                                    onChange={(event) =>
                                                      event.target.value > -1 &&
                                                      this.updateState(
                                                        "adult",
                                                        registerFormField.keyName,
                                                        event.target.value
                                                      )
                                                    }
                                                    placeholder={
                                                      registerFormField.placeholder
                                                    }
                                                    required={
                                                      registerFormField.required
                                                    }
                                                  />
                                                  {registerFormField.keyName ===
                                                    "phone" && (
                                                    <>
                                                      {this.state
                                                        .phoneOtpVerified &&
                                                      !this.state
                                                        .disabledFields ? (
                                                        <>
                                                          <GoVerified
                                                            size="20px"
                                                            style={{
                                                              margin:
                                                                "auto auto auto 10px",
                                                              outline: " unset",
                                                              color: "green",
                                                            }}
                                                            id="verifiedPhoneTooltip"
                                                            onMouseOver={() =>
                                                              this.setState({
                                                                verifiedPhoneTooltip: true,
                                                              })
                                                            }
                                                            onMouseOut={() =>
                                                              this.setState({
                                                                verifiedPhoneTooltip: false,
                                                              })
                                                            }
                                                          />
                                                          <MdEdit
                                                            size="20px"
                                                            style={{
                                                              cursor: "pointer",
                                                              margin:
                                                                "auto auto auto 10px",
                                                              outline: " unset",
                                                            }}
                                                            onClick={() =>
                                                              this.setState({
                                                                phoneOtp: "",
                                                                phoneOtpSent: false,
                                                                phoneOtpVerified: false,
                                                              })
                                                            }
                                                          />
                                                          <Tooltip
                                                            placement="bottom"
                                                            isOpen={
                                                              this.state
                                                                .verifiedPhoneTooltip
                                                            }
                                                            target="verifiedPhoneTooltip"
                                                            toggle={() => {}}
                                                          >
                                                            Phone Verified
                                                          </Tooltip>
                                                        </>
                                                      ) : !this.state
                                                          .disabledFields ? (
                                                        <>
                                                          <GoUnverified
                                                            size="20px"
                                                            id="unverifiedPhoneTooltip"
                                                            style={{
                                                              margin:
                                                                "auto auto auto 10px",
                                                              outline: " unset",
                                                            }}
                                                            onMouseOver={() =>
                                                              this.setState({
                                                                unverifiedPhoneTooltip: true,
                                                              })
                                                            }
                                                            onMouseOut={() =>
                                                              this.setState({
                                                                unverifiedPhoneTooltip: false,
                                                              })
                                                            }
                                                          />
                                                          <Tooltip
                                                            placement="bottom"
                                                            isOpen={
                                                              this.state
                                                                .unverifiedPhoneTooltip
                                                            }
                                                            target="unverifiedPhoneTooltip"
                                                            toggle={() => {}}
                                                          >
                                                            Phone Unverified
                                                          </Tooltip>
                                                        </>
                                                      ) : null}
                                                    </>
                                                  )}
                                                </div>
                                              </>
                                            )}
                                            {registerFormField.keyName ===
                                              "phone" &&
                                              !this.state.phoneOtpVerified &&
                                              this.state.adult[
                                                registerFormField.keyName
                                              ] && (
                                                <>
                                                  {this.state.phoneOtpSent ? (
                                                    <>
                                                      <FormGroup className="mt-3">
                                                        <Label>
                                                          Verify Phone
                                                        </Label>
                                                        <OtpInput
                                                          className="otpInput d-flex justify-content-center"
                                                          inputStyle={{
                                                            color: "#17517b",
                                                            width: "3rem",
                                                            height: "3rem",
                                                            margin: "0 1rem",
                                                            fontSize: "2rem",
                                                            borderRadius: "4px",
                                                            border:
                                                              "1px solid rgba(0,0,0,0.3)",
                                                            outlineColor:
                                                              "#17517b",
                                                          }}
                                                          // shouldAutoFocus={true}
                                                          isInputNum={true}
                                                          value={
                                                            this.state.phoneOtp
                                                          }
                                                          onChange={(value) =>
                                                            this.setState({
                                                              phoneOtp: value,
                                                            })
                                                          }
                                                          numInputs={4}
                                                          separator={
                                                            <span>-</span>
                                                          }
                                                        />
                                                      </FormGroup>
                                                      <Button
                                                        onClick={(event) =>
                                                          this.verifyOTP(
                                                            event,
                                                            "phone"
                                                          )
                                                        }
                                                      >
                                                        Verify OTP
                                                      </Button>
                                                      <Button
                                                        className="ml-2"
                                                        onClick={(event) =>
                                                          this.sendOTP(
                                                            event,
                                                            "phone"
                                                          )
                                                        }
                                                      >
                                                        Resend OTP
                                                      </Button>
                                                    </>
                                                  ) : (
                                                    <Button
                                                      className="mt-3"
                                                      onClick={(event) =>
                                                        this.sendOTP(
                                                          event,
                                                          "phone"
                                                        )
                                                      }
                                                    >
                                                      Send OTP
                                                    </Button>
                                                  )}
                                                </>
                                              )}
                                            {registerFormField.inputType ===
                                              "datepicker" && (
                                              <>
                                                <Label>
                                                  {
                                                    registerFormField.placeholder
                                                  }
                                                  {registerFormField.required && (
                                                    <span
                                                      style={{
                                                        color: "red",
                                                        marginLeft: "5px",
                                                      }}
                                                    >
                                                      *
                                                    </span>
                                                  )}
                                                </Label>
                                                <Input
                                                  id={index}
                                                  disabled={
                                                    this.state.disabledFields
                                                  }
                                                  name={registerFormField.name}
                                                  type="date"
                                                  value={
                                                    this.state.adult[
                                                      registerFormField.keyName
                                                    ] || ""
                                                  }
                                                  onChange={(event) =>
                                                    this.updateState(
                                                      "adult",
                                                      registerFormField.keyName,
                                                      event.target.value
                                                    )
                                                  }
                                                  placeholder={
                                                    registerFormField.placeholder
                                                  }
                                                  required={
                                                    registerFormField.required
                                                  }
                                                />
                                              </>
                                            )}
                                            {registerFormField.inputType ===
                                              "dropdown" && (
                                              <>
                                                <Label>
                                                  {
                                                    registerFormField.placeholder
                                                  }
                                                  {registerFormField.required && (
                                                    <span
                                                      style={{
                                                        color: "red",
                                                        marginLeft: "5px",
                                                      }}
                                                    >
                                                      *
                                                    </span>
                                                  )}
                                                </Label>
                                                <Input
                                                  disabled={
                                                    this.state.disabledFields
                                                  }
                                                  type="select"
                                                  name={registerFormField.name}
                                                  value={
                                                    this.state.adult[
                                                      registerFormField.keyName
                                                    ] || "default"
                                                  }
                                                  required={
                                                    registerFormField.required
                                                  }
                                                  onChange={(event) =>
                                                    this.updateState(
                                                      "adult",
                                                      registerFormField.keyName,
                                                      event.target.value
                                                    )
                                                  }
                                                >
                                                  <option
                                                    value="default"
                                                    disabled
                                                  >
                                                    Select the value
                                                  </option>
                                                  {registerFormField.values.map(
                                                    (value, index) => (
                                                      <option
                                                        key={index}
                                                        value={value}
                                                      >
                                                        {value}
                                                      </option>
                                                    )
                                                  )}
                                                </Input>
                                              </>
                                            )}
                                            {registerFormField.inputType ===
                                              "fileupload" && (
                                              <>
                                                <Label>
                                                  {
                                                    registerFormField.placeholder
                                                  }
                                                  {registerFormField.required && (
                                                    <span
                                                      style={{
                                                        color: "red",
                                                        marginLeft: "5px",
                                                      }}
                                                    >
                                                      *
                                                    </span>
                                                  )}
                                                </Label>
                                                <div>
                                                  {this.state.disabledFields ? (
                                                    <CardImg
                                                      style={{ width: "25%" }}
                                                      key={index}
                                                      src={this.getImageUrl(
                                                        registerFormField.keyName,
                                                        "adult"
                                                      )}
                                                      alt=""
                                                    />
                                                  ) : (
                                                    <>
                                                      <Label
                                                        htmlFor={
                                                          registerFormField._id
                                                        }
                                                      >
                                                        <span className="btn btn-secondary">
                                                          Select File
                                                        </span>
                                                        <span
                                                          style={{
                                                            marginLeft: "5px",
                                                          }}
                                                        >
                                                          {
                                                            this.state.adult[
                                                              `${registerFormField.keyName}FileName`
                                                            ]
                                                          }
                                                        </span>
                                                      </Label>
                                                      <input
                                                        disabled={
                                                          this.state
                                                            .disabledFields
                                                        }
                                                        style={{
                                                          display: "none",
                                                        }}
                                                        id={
                                                          registerFormField._id
                                                        }
                                                        type="file"
                                                        onChange={(event) =>
                                                          this.handleChange(
                                                            "adult",
                                                            registerFormField.keyName,
                                                            event
                                                          )
                                                        }
                                                      />
                                                    </>
                                                  )}
                                                </div>
                                              </>
                                            )}
                                          </FormGroup>
                                        </Col>
                                      )
                                    )}
                                  </TabPanel>
                                )
                              )}
                            </Tabs>
                          ) : (
                            this.state.registerFormFieldsAdult.map(
                              (registerFormField, index) => (
                                <Col key={index}>
                                  <FormGroup>
                                    {registerFormField.inputType === "text" && (
                                      <>
                                        <Label>
                                          {registerFormField.placeholder}
                                          {registerFormField.required && (
                                            <span
                                              style={{
                                                color: "red",
                                                marginLeft: "5px",
                                              }}
                                            >
                                              *
                                            </span>
                                          )}
                                        </Label>
                                        <div style={{ display: "flex" }}>
                                          <Input
                                            disabled={
                                              this.state.disabledFields ||
                                              registerFormField.keyName ===
                                                "email"
                                                ? this.state.emailOtpVerified
                                                : false
                                            }
                                            id={index}
                                            name={registerFormField.name}
                                            type="text"
                                            value={
                                              this.state.adult[
                                                registerFormField.keyName
                                              ] || ""
                                            }
                                            onChange={(event) =>
                                              this.updateState(
                                                "adult",
                                                registerFormField.keyName,
                                                event.target.value
                                              )
                                            }
                                            placeholder={
                                              registerFormField.placeholder
                                            }
                                            required={
                                              registerFormField.required
                                            }
                                          />
                                          {registerFormField.keyName ===
                                            "email" && (
                                            <>
                                              {this.state.emailOtpVerified &&
                                              !this.state.disabledFields ? (
                                                <>
                                                  <GoVerified
                                                    size="20px"
                                                    style={{
                                                      margin:
                                                        "auto auto auto 10px",
                                                      outline: " unset",
                                                      color: "green",
                                                    }}
                                                    id="verifiedEmailTooltip"
                                                    onMouseOver={() =>
                                                      this.setState({
                                                        verifiedEmailTooltip: true,
                                                      })
                                                    }
                                                    onMouseOut={() =>
                                                      this.setState({
                                                        verifiedEmailTooltip: false,
                                                      })
                                                    }
                                                  />
                                                  <MdEdit
                                                    size="20px"
                                                    style={{
                                                      cursor: "pointer",
                                                      margin:
                                                        "auto auto auto 10px",
                                                      outline: " unset",
                                                    }}
                                                    onClick={() =>
                                                      this.setState({
                                                        emailOtp: "",
                                                        emailOtpSent: false,
                                                        emailOtpVerified: false,
                                                      })
                                                    }
                                                  />
                                                  <Tooltip
                                                    placement="bottom"
                                                    isOpen={
                                                      this.state
                                                        .verifiedEmailTooltip
                                                    }
                                                    target="verifiedEmailTooltip"
                                                    toggle={() => {}}
                                                  >
                                                    Email Verified
                                                  </Tooltip>
                                                </>
                                              ) : !this.state.disabledFields ? (
                                                <>
                                                  <GoUnverified
                                                    size="20px"
                                                    id="unverifiedEmailTooltip"
                                                    style={{
                                                      margin:
                                                        "auto auto auto 10px",
                                                      outline: " unset",
                                                    }}
                                                    onMouseOver={() =>
                                                      this.setState({
                                                        unverifiedEmailTooltip: true,
                                                      })
                                                    }
                                                    onMouseOut={() =>
                                                      this.setState({
                                                        unverifiedEmailTooltip: false,
                                                      })
                                                    }
                                                  />
                                                  <Tooltip
                                                    placement="bottom"
                                                    isOpen={
                                                      this.state
                                                        .unverifiedEmailTooltip
                                                    }
                                                    target="unverifiedEmailTooltip"
                                                    toggle={() => {}}
                                                  >
                                                    Email Unverified
                                                  </Tooltip>
                                                </>
                                              ) : null}
                                            </>
                                          )}
                                        </div>
                                      </>
                                    )}
                                    {registerFormField.keyName === "email" &&
                                      !this.state.emailOtpVerified &&
                                      this.state.adult[
                                        registerFormField.keyName
                                      ] && (
                                        <>
                                          {this.state.emailOtpSent ? (
                                            <>
                                              <FormGroup className="mt-3">
                                                <Label>Verify Email</Label>
                                                <OtpInput
                                                  className="otpInput d-flex justify-content-center"
                                                  inputStyle={{
                                                    color: "#17517b",
                                                    width: "3rem",
                                                    height: "3rem",
                                                    margin: "0 1rem",
                                                    fontSize: "2rem",
                                                    borderRadius: "4px",
                                                    border:
                                                      "1px solid rgba(0,0,0,0.3)",
                                                    outlineColor: "#17517b",
                                                  }}
                                                  // shouldAutoFocus={true}
                                                  isInputNum={true}
                                                  value={this.state.emailOtp}
                                                  onChange={(value) =>
                                                    this.setState({
                                                      emailOtp: value,
                                                    })
                                                  }
                                                  numInputs={4}
                                                  separator={<span>-</span>}
                                                />
                                              </FormGroup>
                                              <Button
                                                onClick={(event) =>
                                                  this.verifyOTP(event, "email")
                                                }
                                              >
                                                Verify OTP
                                              </Button>
                                              <Button
                                                className="ml-2"
                                                onClick={(event) =>
                                                  this.sendOTP(event, "email")
                                                }
                                              >
                                                Resend OTP
                                              </Button>
                                            </>
                                          ) : (
                                            <Button
                                              className="mt-3"
                                              onClick={(event) =>
                                                this.sendOTP(event, "email")
                                              }
                                            >
                                              Send OTP
                                            </Button>
                                          )}
                                        </>
                                      )}
                                    {registerFormField.inputType ===
                                      "number" && (
                                      <>
                                        <Label>
                                          {registerFormField.placeholder}
                                          {registerFormField.required && (
                                            <span
                                              style={{
                                                color: "red",
                                                marginLeft: "5px",
                                              }}
                                            >
                                              *
                                            </span>
                                          )}
                                        </Label>
                                        <div style={{ display: "flex" }}>
                                          {registerFormField.keyName ===
                                            "phone" && this.state.redirect ? (
                                            <Input
                                              id={index}
                                              disabled
                                              name={registerFormField.name}
                                              type="number"
                                              value={
                                                this.state.adult[
                                                  registerFormField.keyName
                                                ] || ""
                                              }
                                            />
                                          ) : (
                                            <Input
                                              id={index}
                                              disabled={
                                                this.state.disabledFields ||
                                                registerFormField.keyName ===
                                                  "phone"
                                                  ? this.state.phoneOtpVerified
                                                  : false
                                              }
                                              name={registerFormField.name}
                                              type="number"
                                              value={
                                                this.state.adult[
                                                  registerFormField.keyName
                                                ] || ""
                                              }
                                              onChange={(event) =>
                                                event.target.value > -1 &&
                                                this.updateState(
                                                  "adult",
                                                  registerFormField.keyName,
                                                  event.target.value
                                                )
                                              }
                                              placeholder={
                                                registerFormField.placeholder
                                              }
                                              required={
                                                registerFormField.required
                                              }
                                            />
                                          )}
                                          {registerFormField.keyName ===
                                            "phone" && (
                                            <>
                                              {this.state.phoneOtpVerified &&
                                              !this.state.disabledFields ? (
                                                <>
                                                  <GoVerified
                                                    size="20px"
                                                    style={{
                                                      margin:
                                                        "auto auto auto 10px",
                                                      outline: " unset",
                                                      color: "green",
                                                    }}
                                                    id="verifiedPhoneTooltip"
                                                    onMouseOver={() =>
                                                      this.setState({
                                                        verifiedPhoneTooltip: true,
                                                      })
                                                    }
                                                    onMouseOut={() =>
                                                      this.setState({
                                                        verifiedPhoneTooltip: false,
                                                      })
                                                    }
                                                  />
                                                  {!this.state.redirect ? (
                                                    <MdEdit
                                                      size="20px"
                                                      style={{
                                                        cursor: "pointer",
                                                        margin:
                                                          "auto auto auto 10px",
                                                        outline: " unset",
                                                      }}
                                                      onClick={() =>
                                                        this.setState({
                                                          phoneOtp: "",
                                                          phoneOtpSent: false,
                                                          phoneOtpVerified: false,
                                                        })
                                                      }
                                                    />
                                                  ) : null}
                                                  <Tooltip
                                                    placement="bottom"
                                                    isOpen={
                                                      this.state
                                                        .verifiedPhoneTooltip
                                                    }
                                                    target="verifiedPhoneTooltip"
                                                    toggle={() => {}}
                                                  >
                                                    Phone Verified
                                                  </Tooltip>
                                                </>
                                              ) : !this.state.disabledFields ? (
                                                <>
                                                  <GoUnverified
                                                    size="20px"
                                                    id="unverifiedPhoneTooltip"
                                                    style={{
                                                      margin:
                                                        "auto auto auto 10px",
                                                      outline: " unset",
                                                    }}
                                                    onMouseOver={() =>
                                                      this.setState({
                                                        unverifiedPhoneTooltip: true,
                                                      })
                                                    }
                                                    onMouseOut={() =>
                                                      this.setState({
                                                        unverifiedPhoneTooltip: false,
                                                      })
                                                    }
                                                  />
                                                  <Tooltip
                                                    placement="bottom"
                                                    isOpen={
                                                      this.state
                                                        .unverifiedPhoneTooltip
                                                    }
                                                    target="unverifiedPhoneTooltip"
                                                    toggle={() => {}}
                                                  >
                                                    Phone Unverified
                                                  </Tooltip>
                                                </>
                                              ) : null}
                                            </>
                                          )}
                                        </div>
                                      </>
                                    )}
                                    {registerFormField.keyName === "phone" &&
                                      !this.state.phoneOtpVerified &&
                                      this.state.adult[
                                        registerFormField.keyName
                                      ] && (
                                        <>
                                          {this.state.phoneOtpSent ? (
                                            <>
                                              <FormGroup className="mt-3">
                                                <Label>Verify Phone</Label>
                                                <OtpInput
                                                  className="otpInput d-flex justify-content-center"
                                                  inputStyle={{
                                                    color: "#17517b",
                                                    width: "3rem",
                                                    height: "3rem",
                                                    margin: "0 1rem",
                                                    fontSize: "2rem",
                                                    borderRadius: "4px",
                                                    border:
                                                      "1px solid rgba(0,0,0,0.3)",
                                                    outlineColor: "#17517b",
                                                  }}
                                                  // shouldAutoFocus={true}
                                                  isInputNum={true}
                                                  value={this.state.phoneOtp}
                                                  onChange={(value) =>
                                                    this.setState({
                                                      phoneOtp: value,
                                                    })
                                                  }
                                                  numInputs={4}
                                                  separator={<span>-</span>}
                                                />
                                              </FormGroup>
                                              <Button
                                                onClick={(event) =>
                                                  this.verifyOTP(event, "phone")
                                                }
                                              >
                                                Verify OTP
                                              </Button>
                                              <Button
                                                className="ml-2"
                                                onClick={(event) =>
                                                  this.sendOTP(event, "phone")
                                                }
                                              >
                                                Resend OTP
                                              </Button>
                                            </>
                                          ) : (
                                            <Button
                                              className="mt-3"
                                              onClick={(event) =>
                                                this.sendOTP(event, "phone")
                                              }
                                            >
                                              Send OTP
                                            </Button>
                                          )}
                                        </>
                                      )}
                                    {registerFormField.inputType ===
                                      "datepicker" && (
                                      <>
                                        <Label>
                                          {registerFormField.placeholder}
                                          {registerFormField.required && (
                                            <span
                                              style={{
                                                color: "red",
                                                marginLeft: "5px",
                                              }}
                                            >
                                              *
                                            </span>
                                          )}
                                        </Label>
                                        <Input
                                          id={index}
                                          disabled={this.state.disabledFields}
                                          name={registerFormField.name}
                                          type="date"
                                          value={
                                            this.state.adult[
                                              registerFormField.keyName
                                            ] || ""
                                          }
                                          onChange={(event) =>
                                            this.updateState(
                                              "adult",
                                              registerFormField.keyName,
                                              event.target.value
                                            )
                                          }
                                          placeholder={
                                            registerFormField.placeholder
                                          }
                                          required={registerFormField.required}
                                        />
                                      </>
                                    )}
                                    {registerFormField.inputType ===
                                      "dropdown" && (
                                      <>
                                        <Label>
                                          {registerFormField.placeholder}
                                          {registerFormField.required && (
                                            <span
                                              style={{
                                                color: "red",
                                                marginLeft: "5px",
                                              }}
                                            >
                                              *
                                            </span>
                                          )}
                                        </Label>
                                        <Input
                                          disabled={this.state.disabledFields}
                                          type="select"
                                          name={registerFormField.name}
                                          value={
                                            this.state.adult[
                                              registerFormField.keyName
                                            ] || "default"
                                          }
                                          required={registerFormField.required}
                                          onChange={(event) =>
                                            this.updateState(
                                              "adult",
                                              registerFormField.keyName,
                                              event.target.value
                                            )
                                          }
                                        >
                                          <option value="default" disabled>
                                            Select the value
                                          </option>
                                          {registerFormField.values.map(
                                            (value, index) => (
                                              <option key={index} value={value}>
                                                {value}
                                              </option>
                                            )
                                          )}
                                        </Input>
                                      </>
                                    )}
                                    {registerFormField.inputType ===
                                      "fileupload" && (
                                      <>
                                        <Label>
                                          {registerFormField.placeholder}
                                          {registerFormField.required && (
                                            <span
                                              style={{
                                                color: "red",
                                                marginLeft: "5px",
                                              }}
                                            >
                                              *
                                            </span>
                                          )}
                                        </Label>
                                        <div>
                                          {this.state.disabledFields ? (
                                            <CardImg
                                              style={{ width: "25%" }}
                                              key={index}
                                              src={this.getImageUrl(
                                                registerFormField.keyName,
                                                "adult"
                                              )}
                                              alt=""
                                            />
                                          ) : (
                                            <>
                                              <Label
                                                htmlFor={registerFormField._id}
                                              >
                                                <span className="btn btn-secondary">
                                                  Select File
                                                </span>
                                                <span
                                                  style={{ marginLeft: "5px" }}
                                                >
                                                  {
                                                    this.state.adult[
                                                      `${registerFormField.keyName}FileName`
                                                    ]
                                                  }
                                                </span>
                                              </Label>
                                              <input
                                                disabled={
                                                  this.state.disabledFields
                                                }
                                                style={{ display: "none" }}
                                                id={registerFormField._id}
                                                type="file"
                                                onChange={(event) =>
                                                  this.handleChange(
                                                    "adult",
                                                    registerFormField.keyName,
                                                    event
                                                  )
                                                }
                                              />
                                            </>
                                          )}
                                        </div>
                                      </>
                                    )}
                                  </FormGroup>
                                </Col>
                              )
                            )
                          )}
                          {this.state.wavierFormFieldsAdult.length &&
                          !this.state.disabledFields ? (
                            <>
                              <Col
                                style={{
                                  textAlign: "center",
                                  padding: "10px 0px",
                                  borderTop: "3px solid #e4e5e6",
                                }}
                              >
                                <h3>
                                  {this.state.event.teamRegistration
                                    ? "Waviers For Team"
                                    : "Waviers For Adult"}
                                </h3>
                              </Col>
                              {this.state.wavierFormFieldsAdult.map(
                                (wavierFormField, index) => (
                                  <Col key={index}>
                                    <FormGroup>
                                      {wavierFormField.inputType ===
                                        "waviers" && (
                                        <>
                                          <div className="d-flex">
                                            <CustomInput
                                              type="checkbox"
                                              id={wavierFormField._id}
                                              label={
                                                wavierFormField.placeholder
                                              }
                                              required={
                                                wavierFormField.required
                                              }
                                              checked={
                                                this.state.adult[
                                                  wavierFormField.keyName
                                                ] || false
                                              }
                                              onChange={(event) =>
                                                this.updateState(
                                                  "adult",
                                                  wavierFormField.keyName,
                                                  event.target.value
                                                )
                                              }
                                            />
                                            {wavierFormField.required && (
                                              <span
                                                style={{
                                                  color: "red",
                                                  marginLeft: "5px",
                                                }}
                                              >
                                                *
                                              </span>
                                            )}
                                          </div>
                                          <Input
                                            id={index}
                                            type="textarea"
                                            disabled
                                            style={{ height: "160px" }}
                                            value={wavierFormField.value}
                                          />
                                        </>
                                      )}
                                    </FormGroup>
                                  </Col>
                                )
                              )}
                            </>
                          ) : null}
                        </TabPanel>
                        {this.state.registerChild && (
                          <TabPanel>
                            {!this.state.playerDisabledFields && (
                              <Col xl={6} lg={6} md={12} sm={12}>
                                <FormGroup>
                                  <Label for="exampleCheckbox">
                                    Select Child :
                                  </Label>
                                  <div style={{ display: "flex" }}>
                                    <CustomInput
                                      id="newChild"
                                      type="radio"
                                      label="New Child"
                                      checked={this.state.registerNewChild}
                                      name="newChild"
                                      onClick={(event) => {
                                        this.setState({
                                          player: {},
                                          registerNewChild: true,
                                          showPayButton: false,
                                          multiplePlayers: [
                                            {
                                              registerFormFieldsPlayers: this
                                                .state
                                                .registerFormFieldsPlayers,
                                            },
                                          ],
                                        });
                                      }}
                                    />
                                    <CustomInput
                                      id="existingChild"
                                      type="radio"
                                      label="Existing Child"
                                      checked={!this.state.registerNewChild}
                                      name="newChild"
                                      onClick={(event) => {
                                        let player = this.state.childs.find(
                                          (child) =>
                                            child._id ===
                                            this.state.selectedChild.value
                                        );
                                        // let multiplePlayers = this.state
                                        //   .multiplePlayers.length
                                        //   ? this.state.multiplePlayers
                                        //   : [
                                        //       {
                                        //         registerFormFieldsPlayers: cloneDeep(
                                        //           this.state
                                        //             .registerFormFieldsPlayers
                                        //         ),
                                        //       },
                                        //     ];
                                        // if (
                                        //   player &&
                                        //   player.data.playerQuantity > 0
                                        // ) {
                                        //   multiplePlayers = [];
                                        //   for (
                                        //     let index = 0;
                                        //     index <
                                        //     Number(player.data.playerQuantity);
                                        //     index++
                                        //   ) {
                                        //     let registerFormFieldsPlayers;
                                        //     if (index === 0) {
                                        //       registerFormFieldsPlayers = cloneDeep(
                                        //         this.state
                                        //           .registerFormFieldsPlayers
                                        //       );
                                        //     } else {
                                        //       registerFormFieldsPlayers = cloneDeep(
                                        //         this.state
                                        //           .registerFormFieldsPlayers
                                        //       );
                                        //       registerFormFieldsPlayers = registerFormFieldsPlayers
                                        //         .filter(
                                        //           (registerFormFieldsPlayer) =>
                                        //             registerFormFieldsPlayer.keyName !==
                                        //             "playerQuantity"
                                        //         )
                                        //         .map(
                                        //           (registerFormFieldsPlayer) =>
                                        //             Object.assign(
                                        //               registerFormFieldsPlayer,
                                        //               {
                                        //                 keyName: `${
                                        //                   registerFormFieldsPlayer.keyName
                                        //                 }${index + 1}`,
                                        //               }
                                        //             )
                                        //         );
                                        //     }
                                        //     multiplePlayers.push({
                                        //       registerFormFieldsPlayers,
                                        //     });
                                        //   }
                                        // }
                                        if (
                                          player &&
                                          player.data.playerQuantity
                                        ) {
                                          player.data.playerQuantity = "1";
                                        }
                                        this.setState({
                                          player: player ? player.data : {},
                                          registerNewChild: player
                                            ? false
                                            : true,
                                          showPayButton: false,
                                          multiplePlayers: [
                                            {
                                              registerFormFieldsPlayers: cloneDeep(
                                                this.state
                                                  .registerFormFieldsPlayers
                                              ),
                                            },
                                          ],
                                        });
                                      }}
                                    />
                                  </div>
                                </FormGroup>
                              </Col>
                            )}
                            {!this.state.registerNewChild &&
                              !this.state.playerDisabledFields && (
                                <Col
                                  style={{
                                    borderBottom: "3px solid #e4e5e6",
                                    margin: "0px 0px 10px 0px",
                                  }}
                                  xl={12}
                                  lg={12}
                                  md={12}
                                  sm={12}
                                >
                                  <FormGroup>
                                    <Label for="name">Select Child :</Label>
                                    <Select
                                      value={this.state.selectedChild}
                                      options={[
                                        ...this.state.childs.map((child) => ({
                                          value: child._id,
                                          label: `${child.data.firstName} ${child.data.lastName}`,
                                        })),
                                      ]}
                                      onChange={(result) => {
                                        let player = this.state.childs.find(
                                          (child) => child._id === result.value
                                        );
                                        // let multiplePlayers = [
                                        //   {
                                        //     registerFormFieldsPlayers: cloneDeep(
                                        //       this.state
                                        //         .registerFormFieldsPlayers
                                        //     ),
                                        //   },
                                        // ];
                                        // if (
                                        //   player &&
                                        //   player.data.playerQuantity > 0
                                        // ) {
                                        //   multiplePlayers = [];
                                        //   for (
                                        //     let index = 0;
                                        //     index <
                                        //     Number(player.data.playerQuantity);
                                        //     index++
                                        //   ) {
                                        //     let registerFormFieldsPlayers;
                                        //     if (index === 0) {
                                        //       registerFormFieldsPlayers = cloneDeep(
                                        //         this.state
                                        //           .registerFormFieldsPlayers
                                        //       );
                                        //     } else {
                                        //       registerFormFieldsPlayers = cloneDeep(
                                        //         this.state
                                        //           .registerFormFieldsPlayers
                                        //       );
                                        //       registerFormFieldsPlayers = registerFormFieldsPlayers
                                        //         .filter(
                                        //           (registerFormFieldsPlayer) =>
                                        //             registerFormFieldsPlayer.keyName !==
                                        //             "playerQuantity"
                                        //         )
                                        //         .map(
                                        //           (registerFormFieldsPlayer) =>
                                        //             Object.assign(
                                        //               registerFormFieldsPlayer,
                                        //               {
                                        //                 keyName: `${registerFormFieldsPlayer.keyName
                                        //                   }${index + 1}`,
                                        //               }
                                        //             )
                                        //         );
                                        //     }
                                        //     multiplePlayers.push({
                                        //       registerFormFieldsPlayers,
                                        //     });
                                        //   }
                                        // }
                                        if (
                                          player &&
                                          player.data.playerQuantity
                                        ) {
                                          player.data.playerQuantity = "1";
                                        }
                                        this.setState({
                                          player: player ? player.data : {},
                                          selectedChild: result,
                                          multiplePlayers: [
                                            {
                                              registerFormFieldsPlayers: cloneDeep(
                                                this.state
                                                  .registerFormFieldsPlayers
                                              ),
                                            },
                                          ],
                                        });
                                      }}
                                    />
                                  </FormGroup>
                                </Col>
                              )}
                            <Tabs style={{ width: "100%" }}>
                              <TabList>
                                {this.state.multiplePlayers.map(
                                  (multiplePlayer, index) => (
                                    <Tab>Player {index + 1}</Tab>
                                  )
                                )}
                              </TabList>
                              {this.state.multiplePlayers.map(
                                (multiplePlayer, index) => (
                                  <TabPanel key={index}>
                                    {multiplePlayer.registerFormFieldsPlayers.map(
                                      (registerFormField, index) => (
                                        <Col key={index}>
                                          <FormGroup>
                                            {registerFormField.inputType ===
                                              "text" && (
                                              <>
                                                <Label>
                                                  {
                                                    registerFormField.placeholder
                                                  }
                                                  {registerFormField.required && (
                                                    <span
                                                      style={{
                                                        color: "red",
                                                        marginLeft: "5px",
                                                      }}
                                                    >
                                                      *
                                                    </span>
                                                  )}
                                                </Label>
                                                <Input
                                                  disabled={
                                                    this.state
                                                      .playerDisabledFields
                                                  }
                                                  id={index}
                                                  name={registerFormField.name}
                                                  type="text"
                                                  value={
                                                    this.state.player[
                                                      registerFormField.keyName
                                                    ] || ""
                                                  }
                                                  onChange={(event) =>
                                                    this.updateState(
                                                      "player",
                                                      registerFormField.keyName,
                                                      event.target.value
                                                    )
                                                  }
                                                  placeholder={
                                                    registerFormField.placeholder
                                                  }
                                                  required={
                                                    registerFormField.required
                                                  }
                                                />
                                              </>
                                            )}
                                            {registerFormField.inputType ===
                                              "number" && (
                                              <>
                                                <Label>
                                                  {
                                                    registerFormField.placeholder
                                                  }
                                                  {registerFormField.required && (
                                                    <span
                                                      style={{
                                                        color: "red",
                                                        marginLeft: "5px",
                                                      }}
                                                    >
                                                      *
                                                    </span>
                                                  )}
                                                </Label>
                                                <Input
                                                  disabled={
                                                    this.state
                                                      .playerDisabledFields
                                                  }
                                                  id={index}
                                                  name={registerFormField.name}
                                                  type="number"
                                                  value={
                                                    this.state.player[
                                                      registerFormField.keyName
                                                    ] || ""
                                                  }
                                                  onChange={(event) =>
                                                    event.target.value > -1 &&
                                                    this.updateState(
                                                      "player",
                                                      registerFormField.keyName,
                                                      event.target.value
                                                    )
                                                  }
                                                  placeholder={
                                                    registerFormField.placeholder
                                                  }
                                                  required={
                                                    registerFormField.required
                                                  }
                                                />
                                              </>
                                            )}
                                            {registerFormField.inputType ===
                                              "datepicker" && (
                                              <>
                                                <Label>
                                                  {
                                                    registerFormField.placeholder
                                                  }
                                                  {registerFormField.required && (
                                                    <span
                                                      style={{
                                                        color: "red",
                                                        marginLeft: "5px",
                                                      }}
                                                    >
                                                      *
                                                    </span>
                                                  )}
                                                </Label>
                                                <Input
                                                  disabled={
                                                    this.state
                                                      .playerDisabledFields
                                                  }
                                                  id={index}
                                                  name={registerFormField.name}
                                                  type="date"
                                                  value={
                                                    this.state.player[
                                                      registerFormField.keyName
                                                    ] || ""
                                                  }
                                                  onChange={(event) =>
                                                    this.updateState(
                                                      "player",
                                                      registerFormField.keyName,
                                                      event.target.value
                                                    )
                                                  }
                                                  placeholder={
                                                    registerFormField.placeholder
                                                  }
                                                  required={
                                                    registerFormField.required
                                                  }
                                                />
                                              </>
                                            )}
                                            {registerFormField.inputType ===
                                              "dropdown" && (
                                              <>
                                                <Label>
                                                  {
                                                    registerFormField.placeholder
                                                  }
                                                  {registerFormField.required && (
                                                    <span
                                                      style={{
                                                        color: "red",
                                                        marginLeft: "5px",
                                                      }}
                                                    >
                                                      *
                                                    </span>
                                                  )}
                                                </Label>
                                                <Input
                                                  disabled={
                                                    this.state
                                                      .playerDisabledFields
                                                  }
                                                  type="select"
                                                  name={registerFormField.name}
                                                  value={
                                                    this.state.player[
                                                      registerFormField.keyName
                                                    ] || "default"
                                                  }
                                                  required={
                                                    registerFormField.required
                                                  }
                                                  onChange={(event) =>
                                                    this.updateState(
                                                      "player",
                                                      registerFormField.keyName,
                                                      event.target.value
                                                    )
                                                  }
                                                >
                                                  <option
                                                    value="default"
                                                    disabled
                                                  >
                                                    Select the value
                                                  </option>
                                                  {registerFormField.values.map(
                                                    (value, index) => (
                                                      <option
                                                        key={index}
                                                        value={value}
                                                      >
                                                        {value}
                                                      </option>
                                                    )
                                                  )}
                                                </Input>
                                              </>
                                            )}
                                            {registerFormField.inputType ===
                                              "fileupload" && (
                                              <>
                                                <Label>
                                                  {
                                                    registerFormField.placeholder
                                                  }
                                                  {registerFormField.required && (
                                                    <span
                                                      style={{
                                                        color: "red",
                                                        marginLeft: "5px",
                                                      }}
                                                    >
                                                      *
                                                    </span>
                                                  )}
                                                </Label>
                                                <div>
                                                  {this.state
                                                    .playerDisabledFields ? (
                                                    <CardImg
                                                      style={{ width: "25%" }}
                                                      key={index}
                                                      src={this.getImageUrl(
                                                        registerFormField.keyName,
                                                        "player"
                                                      )}
                                                      alt=""
                                                    />
                                                  ) : (
                                                    <>
                                                      <Label
                                                        htmlFor={
                                                          registerFormField._id
                                                        }
                                                      >
                                                        <span className="btn btn-secondary">
                                                          Select File
                                                        </span>
                                                        <span
                                                          style={{
                                                            marginLeft: "5px",
                                                          }}
                                                        >
                                                          {
                                                            this.state.player[
                                                              `${registerFormField.keyName}FileName`
                                                            ]
                                                          }
                                                        </span>
                                                      </Label>
                                                      <input
                                                        style={{
                                                          display: "none",
                                                        }}
                                                        id={
                                                          registerFormField._id
                                                        }
                                                        type="file"
                                                        onChange={(event) =>
                                                          this.handleChange(
                                                            "player",
                                                            registerFormField.keyName,
                                                            event
                                                          )
                                                        }
                                                      />
                                                    </>
                                                  )}
                                                </div>
                                              </>
                                            )}
                                          </FormGroup>
                                        </Col>
                                      )
                                    )}
                                  </TabPanel>
                                )
                              )}
                            </Tabs>
                            {this.state.wavierFormFieldsPlayers.length &&
                            !this.state.playerDisabledFields ? (
                              <>
                                <Col
                                  style={{
                                    textAlign: "center",
                                    padding: "10px 0px",
                                    borderTop: "3px solid #e4e5e6",
                                  }}
                                >
                                  <h3>Waviers For Players</h3>
                                </Col>
                                {this.state.wavierFormFieldsPlayers.map(
                                  (wavierFormField, index) => (
                                    <Col key={index}>
                                      <FormGroup>
                                        {wavierFormField.inputType ===
                                          "waviers" && (
                                          <>
                                            <div className="d-flex">
                                              <CustomInput
                                                type="checkbox"
                                                id={wavierFormField._id}
                                                label={
                                                  wavierFormField.placeholder
                                                }
                                                required={
                                                  wavierFormField.required
                                                }
                                                checked={
                                                  this.state.player[
                                                    wavierFormField.keyName
                                                  ] || false
                                                }
                                                onChange={(event) =>
                                                  this.updateState(
                                                    "player",
                                                    wavierFormField.keyName,
                                                    event.target.value
                                                  )
                                                }
                                              />
                                              {wavierFormField.required && (
                                                <span
                                                  style={{
                                                    color: "red",
                                                    marginLeft: "5px",
                                                  }}
                                                >
                                                  *
                                                </span>
                                              )}
                                            </div>
                                            <Input
                                              id={index}
                                              type="textarea"
                                              disabled
                                              style={{ height: "160px" }}
                                              value={wavierFormField.value}
                                            />
                                          </>
                                        )}
                                      </FormGroup>
                                    </Col>
                                  )
                                )}
                              </>
                            ) : null}
                          </TabPanel>
                        )}
                      </Tabs>
                      <Col
                        style={{
                          padding: "5px 0px",
                          borderTop: "3px solid #e4e5e6",
                        }}
                      ></Col>
                      <Col
                        style={{
                          textAlign: "center",
                        }}
                      >
                        {this.state.registerChild ? (
                          // this.state.showPayButton ? (
                          //   <Button
                          //     type="submit"
                          //     className="ml-2"
                          //     onClick={() =>
                          //       this.setState({
                          //         showPaymentPage: true,
                          //       })
                          //     }
                          //   >
                          //     Go to payment page
                          //   </Button>
                          // ) : (
                          <Button
                            type="submit"
                            onClick={() =>
                              this.setState({
                                registerFor: "child",
                                submitType: "submit",
                              })
                            }
                          >
                            Register Player
                          </Button>
                        ) : (
                          <Button
                            disabled={
                              !this.state.phoneOtpVerified ||
                              !this.state.emailOtpVerified
                            }
                            type="submit"
                            onClick={() =>
                              this.setState({
                                registerFor: "parent",
                                submitType: "submit",
                              })
                            }
                          >
                            {this.state.event.teamRegistration
                              ? "Register Team"
                              : "Register Parent"}
                          </Button>
                        )}
                      </Col>
                    </Form>
                  ) : (
                    <Form className="form" onSubmit={this.verifyCode}>
                      <Col xl={6} lg={6} md={12} sm={12}>
                        <FormGroup>
                          <Label>Verification Code</Label>
                          <OtpInput
                            className="otpInput d-flex justify-content-center"
                            inputStyle={{
                              color: "#17517b",
                              width: "3rem",
                              height: "3rem",
                              margin: "0 1rem",
                              fontSize: "2rem",
                              borderRadius: "4px",
                              border: "1px solid rgba(0,0,0,0.3)",
                              outlineColor: "#17517b",
                            }}
                            shouldAutoFocus={true}
                            isInputNum={true}
                            value={this.state.code}
                            onChange={(value) =>
                              this.setState({
                                code: value,
                              })
                            }
                            numInputs={4}
                            separator={<span>-</span>}
                          />
                        </FormGroup>
                      </Col>
                      <Col xl={6} lg={6} md={12} sm={12}>
                        <Button>Verify Code</Button>
                      </Col>
                    </Form>
                  )}
                </div>
                {this.state.verificationModal ? (
                  <Modal
                    isOpen={this.state.verificationModal}
                    toggle={(event) => this.toggleVerificationModal()}
                    className="modal-md"
                  >
                    <ModalHeader
                      style={{
                        background: "#f8f9fa",
                      }}
                      toggle={(event) => this.toggleVerificationModal()}
                    >
                      Confirmantion
                    </ModalHeader>
                    <ModalBody
                      style={{
                        background: "#f8f9fa",
                      }}
                    >
                      <Row>
                        <Col>
                          <FormGroup>
                            <Label>Are you sure you want to register?</Label>
                          </FormGroup>
                        </Col>
                      </Row>
                    </ModalBody>
                    <ModalFooter
                      style={{
                        background: "#f8f9fa",
                      }}
                    >
                      <Form className="form" onSubmit={this.onSubmit}>
                        <Button
                          type="submit"
                          onClick={() =>
                            this.state.registerChild
                              ? this.setState({
                                  submitType: "registerChild",
                                })
                              : this.setState({
                                  submitType: "registerAdult",
                                })
                          }
                        >
                          Register
                        </Button>
                      </Form>
                      <Button onClick={() => this.toggleVerificationModal()}>
                        Cancel
                      </Button>{" "}
                    </ModalFooter>
                  </Modal>
                ) : null}
              </Container>
            ) : (
              <Container>
                <PageSpinner showLoader={this.state.showLoader} />
                <div
                  className="login-form"
                  style={{
                    marginTop: "20px",
                    maxWidth: "unset",
                  }}
                >
                  <Col
                    style={{
                      textAlign: "center",
                      borderBottom: "3px solid #e4e5e6",
                      marginBottom: "10px",
                    }}
                  >
                    {this.state.showLoader ? (
                      <h2>Loading...</h2>
                    ) : (
                      <h2>Registration form not found</h2>
                    )}
                  </Col>
                </div>
              </Container>
            )}
          </>
        )}
        {this.state.paymentSuccessConfirmationModal ? (
          <Modal
            isOpen={this.state.paymentSuccessConfirmationModal}
            toggle={(event) => this.togglePaymentSuccessConfirmationModal()}
            className="modal-md"
          >
            <ModalHeader
              style={{
                justifyContent: "center",
                background: "rgb(53 103 140)",
              }}
            >
              <FaRegCheckCircle
                size="100px"
                style={{ color: "#ffffff" }}
              ></FaRegCheckCircle>
              <br />
              <h3
                className="mt-2"
                style={{ fontWeight: "bold", color: "#ffffff" }}
              >
                Success
              </h3>
            </ModalHeader>
            <ModalBody
              style={{
                background: "#f8f9fa",
              }}
            >
              <Row>
                <Col style={{ textAlign: "center" }}>
                  <h2 style={{ fontWeight: "bold" }}>Payment Successfull</h2>
                  <h4>
                    Your payment is completed for{" "}
                    {this.state.selectedEventForAPI.label
                      ? this.state.selectedEventForAPI.label
                      : ""}
                  </h4>
                </Col>
              </Row>
              <Row>
                <Col style={{ textAlign: "center" }}>
                  <h4>
                    Event Name : {this.state.event ? this.state.event.name : ""}
                  </h4>
                </Col>
              </Row>
              <Row>
                <Col style={{ textAlign: "center" }}>
                  <p>You can download the app from Play Store or App Store</p>
                </Col>
              </Row>
              <Row
                className="mb-2"
                style={{ borderBottom: "1px solid #dee2e6" }}
              >
                <Col
                  style={{ margin: "auto", textAlign: "center" }}
                  sm={6}
                  md={6}
                  lg={6}
                  xl={6}
                >
                  <img
                    src="https://image.zocial.io/playstore.png"
                    className="img-responsive mb-2"
                    alt=""
                    style={{ width: "100px" }}
                  />
                </Col>
                <Col
                  style={{ margin: "auto", textAlign: "center" }}
                  sm={6}
                  md={6}
                  lg={6}
                  xl={6}
                >
                  <img
                    src="https://image.zocial.io/rushsoccer_playstore.png"
                    className="img-responsive mb-2"
                    alt=""
                    style={{ width: "100px" }}
                  />
                </Col>
              </Row>
              <Row className="mb-2">
                <Col
                  style={{ margin: "auto", textAlign: "center" }}
                  sm={6}
                  md={6}
                  lg={6}
                  xl={6}
                >
                  <img
                    src="https://image.zocial.io/appstore.png"
                    className="img-responsive"
                    alt=""
                    style={{ width: "100px" }}
                  />
                </Col>
                <Col
                  style={{ margin: "auto", textAlign: "center" }}
                  sm={6}
                  md={6}
                  lg={6}
                  xl={6}
                >
                  <img
                    src="https://image.zocial.io/rushsoccer_appstore.png"
                    className="img-responsive"
                    alt=""
                    style={{ width: "100px" }}
                  />
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter
              style={{
                justifyContent: "center",
                background: "#f8f9fa",
              }}
            >
              <Button
                onClick={() => this.togglePaymentSuccessConfirmationModal()}
              >
                Close
              </Button>{" "}
            </ModalFooter>
          </Modal>
        ) : null}
        <NotificationSystem
          dismissible={false}
          ref={(notificationSystem) =>
            (this.notificationSystem = notificationSystem)
          }
          style={NOTIFICATION_SYSTEM_STYLE}
        />
      </Fragment>
    );
  }
}

export default EventRegistrationForm;
